import React, { useState, useEffect, useRef, useMemo } from 'react';
import { 
  X, Zap, Monitor, Smartphone, RefreshCw, Loader2, Send, Sparkles, 
  Plus, Trash2, Star, Play, Check, Globe, Image as ImageIcon,
  ArrowRight, Heart, Award, ShieldCheck, Mail, ArrowUpRight, FileText, Link as LinkIcon, Copy
} from 'lucide-react';
import { auth, db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { parseHtmlFormEmbed } from '../utils/formParser';

const C = {
  bg:'#0d0f14', surface:'#13161d', card:'#1a1d27',
  border:'rgba(255,255,255,0.08)', borderHover:'rgba(255,255,255,0.18)',
  text:'#e8eaf0', muted:'#6b7080',
  orange:'#f97316', green:'#22c55e', red:'#ef4444',
  blue:'#02B6FF', yellow:'#eab308', purple:'#a78bfa', violet:'#8b5cf6',
};

const DEFAULT_IMAGES = [
  "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1000&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?q=80&w=1000&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?q=80&w=1000&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1000&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1542744094-3a31f103e35f?q=80&w=1000&auto=format&fit=crop"
];

const DEFAULT_HTML_TEMPLATES = {
  landing: `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><script src="https://cdn.tailwindcss.com"></script><link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap" rel="stylesheet"><style>body{font-family:'Inter',sans-serif;}</style><title>Exclusive Access | Special Presentation</title></head>
<body class="bg-slate-950 text-slate-300 min-h-screen pb-20 bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-indigo-900/10 via-slate-950 to-black font-sans">
    <header class="max-w-4xl mx-auto px-6 pt-16 pb-8 text-center space-y-4">
        <div class="inline-flex items-center px-3.5 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-black uppercase tracking-[0.2em]">
            ★ SPECIAL PRESENTATION ★
        </div>
        <h1 data-edit-field="headline" contenteditable="true" class="outline-none focus:ring-2 focus:ring-orange-500 rounded-2xl px-3 py-1.5 text-4xl sm:text-6xl font-black text-white tracking-tight leading-none bg-gradient-to-b from-white to-slate-400 bg-clip-text text-transparent">
            Unlock Instant Access
        </h1>
        <p data-edit-field="subheadline" contenteditable="true" class="outline-none focus:ring-2 focus:ring-orange-500 rounded-2xl px-3 py-1.5 text-slate-400 text-lg sm:text-xl max-w-2xl mx-auto leading-relaxed">
            Discover the proven system and secure your access to the complete presentation below.
        </p>
    </header>
    <div class="max-w-4xl mx-auto px-6 mb-12">
        <div class="bg-slate-900/60 border border-slate-800 rounded-[2.5rem] p-6 sm:p-8 space-y-8 shadow-2xl relative overflow-hidden">
            <div class="absolute inset-0 bg-gradient-to-br from-indigo-900/10 via-transparent to-transparent opacity-50"></div>
            <div id="ninja-video-container" class="aspect-video w-full bg-slate-900 rounded-[2.5rem] border border-slate-800 shadow-[0_0_80px_rgba(99,102,241,0.15)] overflow-hidden flex items-center justify-center relative">
                <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1000&auto=format&fit=crop" class="absolute inset-0 w-full h-full object-cover opacity-40" alt="Hero" />
                <div class="absolute inset-0 bg-gradient-to-br from-indigo-900/20 to-purple-900/20"></div>
                <div class="relative z-10 text-center space-y-4">
                    <div class="w-24 h-24 bg-white/5 rounded-full flex items-center justify-center mx-auto border border-white/10"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-12 h-12 text-white/40 ml-1"><path d="M8 5v14l11-7z"/></svg></div>
                </div>
            </div>
            <div class="text-center pt-4 space-y-4">
                <div>
                    <a href="{affiliate_link}" class="inline-flex items-center justify-center bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-black text-lg sm:text-xl px-12 py-5 rounded-2xl shadow-xl shadow-indigo-600/20 hover:shadow-indigo-600/35 transform transition hover:-translate-y-0.5 active:translate-y-0 active:scale-95 duration-200">
                        <span data-edit-field="ctaText" contenteditable="true" class="outline-none focus:ring-2 focus:ring-orange-500 rounded px-2">Get Instant Access →</span>
                    </a>
                </div>
                <p class="text-[10px] text-slate-500 uppercase tracking-widest font-black">100% Free Access · Instant Registration</p>
            </div>
        </div>
    </div>
</body>
</html>`,

  'video-hub': `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><script src="https://cdn.tailwindcss.com"></script><link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap" rel="stylesheet"><style>body{font-family:'Inter',sans-serif;}</style><title>Affiliate Marketing Mastery Course</title></head>
<body class="bg-slate-955 text-white min-h-screen flex flex-col bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-indigo-900/10 via-slate-950 to-black font-sans">
  <header class="border-b border-slate-900 bg-slate-950/80 backdrop-blur-md px-6 py-4 flex flex-col md:flex-row md:items-center justify-between gap-4 sticky top-0 z-50">
    <div class="space-y-1">
      <div class="flex items-center gap-2">
        <span class="text-indigo-400 font-black text-[9px] uppercase tracking-[0.2em] bg-indigo-500/10 border border-indigo-500/20 px-2 py-0.5 rounded">Training Portal</span>
      </div>
      <h1 class="text-xl font-black tracking-tight text-white">Affiliate Marketing Mastery Course</h1>
      <p class="text-xs text-slate-400">Watch the training below to build and scale your campaigns.</p>
    </div>
    <div>
      <a href="{affiliate_link}" class="inline-flex items-center justify-center bg-gradient-to-r from-emerald-600 to-indigo-600 hover:from-emerald-500 hover:to-indigo-500 text-white font-extrabold text-xs uppercase tracking-wider px-6 py-3 rounded-xl shadow-lg transition duration-200">
        Deploy Your Affiliate Flow AI Engine &rarr;
      </a>
    </div>
  </header>

  <div class="flex-1 flex flex-col md:flex-row max-w-7xl w-full mx-auto p-4 md:p-6 gap-6 overflow-hidden">
    <div class="flex-1 space-y-4">
      <div class="aspect-video w-full bg-slate-900 rounded-2xl border border-slate-805 shadow-2xl relative overflow-hidden flex items-center justify-center">
        <div id="video-placeholder" class="w-full h-full">
          <iframe id="video-player" class="w-full h-full border-none" src="" allowfullscreen></iframe>
        </div>
      </div>
      <div class="bg-slate-900/40 border border-slate-900 rounded-2xl p-6 space-y-3">
        <h2 id="current-lesson-title" class="text-lg font-black text-white">Select a lesson to begin training</h2>
        <p id="current-lesson-desc" class="text-sm text-slate-400 leading-relaxed">Please choose a module from the course curriculum sidebar to play the video instruction.</p>
      </div>
    </div>

    <div class="w-full md:w-80 bg-slate-900/60 border border-slate-900 rounded-2xl p-4 flex flex-col h-[60vh] md:h-auto overflow-y-auto" id="lesson-sidebar">
    </div>
  </div>

  <script>
    const courseData = {course_data_json};

    let activeSection = 0;
    let activeLesson = 0;

    function renderCourse() {
      const sidebar = document.getElementById('lesson-sidebar');
      sidebar.innerHTML = '';
      
      if (!courseData || !courseData.sections || courseData.sections.length === 0) {
        sidebar.innerHTML = '<div class="text-slate-500 text-xs p-4 text-center">No lessons added yet.</div>';
        return;
      }

      courseData.sections.forEach((section, sIdx) => {
        const secDiv = document.createElement('div');
        secDiv.className = 'sec-container mb-5';
        
        const secTitle = document.createElement('h3');
        secTitle.className = 'text-[9px] font-black text-slate-500 uppercase tracking-widest px-3 py-1.5 border-b border-slate-800/80 mb-2 flex items-center justify-between';
        secTitle.innerHTML = \`<span>\${section.title}</span> <span class="text-[9px] bg-slate-800 px-1.5 py-0.5 rounded text-slate-400 font-bold">\${section.lessons ? section.lessons.length : 0} Lessons</span>\`;
        secDiv.appendChild(secTitle);
        
        const lessonList = document.createElement('div');
        lessonList.className = 'space-y-1';
        
        if (section.lessons) {
          section.lessons.forEach((lesson, lIdx) => {
            const isActive = sIdx === activeSection && lIdx === activeLesson;
            const btn = document.createElement('button');
            btn.className = \`w-full text-left px-3 py-2.5 rounded-xl text-[11px] flex items-start gap-2.5 transition-all border \${
              isActive 
                ? 'bg-indigo-600/10 text-indigo-400 border-indigo-500/20 font-bold' 
                : 'text-slate-400 hover:bg-slate-950/40 hover:text-slate-200 border-transparent'
            }\`;
            btn.onclick = () => selectLesson(sIdx, lIdx);
            
            btn.innerHTML = \`
              <span class="mt-0.5">\${isActive ? '▶️' : '📄'}</span>
              <div class="flex-1 min-w-0">
                <div class="truncate font-semibold">\${lesson.title}</div>
                <div class="text-[9px] text-slate-500 mt-0.5">\${lesson.dur || '10m 00s'}</div>
              </div>
            \`;
            lessonList.appendChild(btn);
          });
        }
        
        secDiv.appendChild(secTitle);
        secDiv.appendChild(lessonList);
        sidebar.appendChild(secDiv);
      });

      const activeSecObj = courseData.sections[activeSection];
      if (activeSecObj && activeSecObj.lessons) {
        const activeLesObj = activeSecObj.lessons[activeLesson];
        if (activeLesObj) {
          document.getElementById('current-lesson-title').innerText = activeLesObj.title;
          document.getElementById('current-lesson-desc').innerText = activeLesObj.desc || '';
          
          const player = document.getElementById('video-player');
          const vUrl = activeLesObj.videoUrl || '';
          
          if (vUrl.includes('youtube.com/embed') || vUrl.includes('player.vimeo.com')) {
            player.outerHTML = \`<iframe id="video-player" class="w-full h-full border-none" src="\${vUrl}" allowfullscreen></iframe>\`;
          } else if (vUrl.includes('youtube.com/watch') || vUrl.includes('youtu.be')) {
            let embedUrl = vUrl;
            if (vUrl.includes('youtube.com/watch')) {
              const regExp = /^.*(youtu.be\\/|v\\/|u\\/\\w\\/|embed\\/|watch\\?v=|\\&v=)([^#\\&\\?]*).*/;
              const match = vUrl.match(regExp);
              if (match && match[2].length === 11) {
                embedUrl = \`https://www.youtube.com/embed/\${match[2]}?autoplay=0\`;
              }
            } else {
              const id = vUrl.split('/').pop();
              embedUrl = \`https://www.youtube.com/embed/\${id}?autoplay=0\`;
            }
            player.outerHTML = \`<iframe id="video-player" class="w-full h-full border-none" src="\${embedUrl}" allowfullscreen></iframe>\`;
          } else if (vUrl) {
            player.outerHTML = \`<video id="video-player" class="w-full h-full object-cover" controls src="\${vUrl}"></video>\`;
          } else {
            player.outerHTML = \`<div id="video-player" class="w-full h-full flex flex-col items-center justify-center text-slate-600 bg-slate-950 text-xs">
              <span class="text-3xl mb-2">🎬</span> No Video Configured
            </div>\`;
          }
        }
      }
    }

    function selectLesson(sIdx, lIdx) {
      activeSection = sIdx;
      activeLesson = lIdx;
      renderCourse();
    }

    document.addEventListener('DOMContentLoaded', renderCourse);
  </script>
</body></html>`,

  advertorial: `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0">
    <script src="https://cdn.tailwindcss.com"></script>
    <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;700;900&display=swap" rel="stylesheet">
    <style>body { font-family: 'Outfit', sans-serif; }</style>
</head>
<body class="bg-slate-955 text-slate-300 min-h-screen pb-20">
    <nav class="bg-slate-900 border-b border-slate-850 py-4 px-6 mb-12">
        <div class="max-w-4xl mx-auto flex justify-between items-center">
            <span class="text-white font-black tracking-widest text-lg">DAILY INSIDER JOURNAL</span>
            <span class="text-xs text-amber-400 font-bold bg-amber-400/10 border border-amber-500/20 px-3 py-1 rounded-full uppercase tracking-wider">Sponsored Editorial Report</span>
        </div>
    </nav>
    <article class="max-w-3xl mx-auto px-6 space-y-8 bg-slate-900/40 p-8 sm:p-12 border border-slate-850 rounded-[2.5rem]">
        <div class="space-y-4">
            <h1 data-edit-field="headline" contenteditable="true" class="outline-none focus:ring-2 focus:ring-orange-500 rounded-2xl px-3 py-1.5 text-4xl sm:text-5xl font-black text-white leading-tight">
                Write a compelling advertorial headline...
            </h1>
            <div class="flex items-center space-x-3 text-xs text-slate-500 font-bold pt-2 border-y border-slate-850 py-3">
                <span>By Ronald Vance</span>
                <span>â€¢</span>
                <span>Updated: May 2026</span>
                <span>â€¢</span>
                <span class="text-emerald-400">âœ“ Verified Editorial Quality</span>
            </div>
        </div>
        
        <p data-edit-field="subheadline" contenteditable="true" class="outline-none focus:ring-2 focus:ring-orange-500 rounded-2xl px-3 py-1.5 text-lg leading-relaxed text-slate-350">
            Subheadline explaining the editorial hook...
        </p>
        
        <div class="aspect-video bg-slate-900 rounded-3xl overflow-hidden border border-slate-800 flex items-center justify-center">
            <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1000&auto=format&fit=crop" class="w-full h-full object-cover" alt="Hero" />
        </div>

        <p data-edit-field="body" contenteditable="true" class="outline-none focus:ring-2 focus:ring-orange-500 rounded-2xl px-3 py-1.5 text-lg leading-relaxed text-slate-300">
            This is where you write the pre-sell story. Warm up the visitors with a great hook, build social proof, and lead them to the affiliate link...
        </p>
        
        <div class="text-center pt-6">
            <a href="{affiliate_link}" class="inline-block bg-gradient-to-r from-amber-500 via-purple-600 to-indigo-600 hover:from-amber-400 hover:to-indigo-500 text-white font-black text-lg px-12 py-5 rounded-2xl transition shadow-xl shadow-amber-500/20 transform active:scale-95">
                <span data-edit-field="ctaText" contenteditable="true" class="outline-none focus:ring-2 focus:ring-orange-500 rounded px-2">Claim Your Deal Now â†’</span>
            </a>
            <p class="text-slate-600 text-xs font-bold uppercase tracking-widest mt-4">Limited Access Slots Remaining for Today</p>
        </div>
    </article>
</body>
</html>`,

  listicle: `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0">
    <script src="https://cdn.tailwindcss.com"></script>
    <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;700;900&display=swap" rel="stylesheet">
    <style>body { font-family: 'Outfit', sans-serif; }</style>
</head>
<body class="bg-slate-955 text-slate-300 min-h-screen pb-20">
    <header class="max-w-4xl mx-auto px-6 pt-16 pb-8 text-center space-y-4">
        <div class="inline-flex items-center px-3.5 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-black uppercase tracking-[0.2em]">
            â˜… RECOMMENDED PRODUCTS â˜…
        </div>
        <h1 data-edit-field="headline" contenteditable="true" class="outline-none focus:ring-2 focus:ring-orange-500 rounded-2xl px-3 py-1.5 text-4xl sm:text-5xl font-black text-white tracking-tight">
            Top Reviewed Products
        </h1>
        <p data-edit-field="subheadline" contenteditable="true" class="outline-none focus:ring-2 focus:ring-orange-500 rounded-2xl px-3 py-1.5 text-slate-400 text-lg max-w-2xl mx-auto leading-relaxed">
            Compare the best options available.
        </p>
    </header>
    <div class="max-w-4xl mx-auto px-6 mb-12">
        <div class="bg-slate-900/60 border border-slate-800 rounded-[2.5rem] p-6 sm:p-8 space-y-8 shadow-2xl relative overflow-hidden">
            <div class="absolute inset-0 bg-gradient-to-br from-indigo-900/10 via-transparent to-transparent opacity-50"></div>
            <div class="aspect-video w-full bg-slate-900 rounded-[2.5rem] border border-slate-800 shadow-[0_0_80px_rgba(99,102,241,0.15)] overflow-hidden flex items-center justify-center relative">
                <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1000&auto=format&fit=crop" class="absolute inset-0 w-full h-full object-cover opacity-40" alt="Hero" />
                <div class="absolute inset-0 bg-gradient-to-br from-indigo-900/20 to-purple-900/20"></div>
                <div class="relative z-10 text-center space-y-4">
                    <div class="w-24 h-24 bg-white/5 rounded-full flex items-center justify-center mx-auto border border-white/10">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-12 h-12 text-white/40 ml-1">
                            <path d="M8 5v14l11-7z"/>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="text-center pt-4 space-y-4">
                <div>
                    <a href="{affiliate_link}" class="inline-flex items-center justify-center bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-black text-lg px-12 py-5 rounded-2xl shadow-xl shadow-indigo-600/20 hover:shadow-indigo-600/35 transform transition hover:-translate-y-0.5 active:translate-y-0 active:scale-95 duration-200">
                        Link â†’
                    </a>
                </div>
            </div>
        </div>
    </div>
</body>
</html>`,

  'capture-popup': `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0">
    <script src="https://cdn.tailwindcss.com"></script>
    <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;700;900&display=swap" rel="stylesheet">
    <style>body { font-family: 'Outfit', sans-serif; }</style>
</head>
<body class="bg-[#020617] text-white min-h-screen flex items-center justify-center p-6">
    <div class="max-w-2xl w-full text-center space-y-8 bg-[#0f172a] p-16 rounded-[2.5rem] border border-slate-800 shadow-2xl relative overflow-hidden">
        <div class="absolute -top-24 -left-24 w-48 h-48 bg-indigo-600/20 rounded-full blur-3xl"></div>
        <div class="absolute -bottom-24 -right-24 w-48 h-48 bg-rose-600/20 rounded-full blur-3xl"></div>
        <div class="relative z-10 space-y-6">
            <div class="inline-flex items-center px-4 py-1.5 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-black uppercase tracking-[0.2em]">
                Exclusive Access
            </div>
            <h1 data-edit-field="headline" contenteditable="true" class="outline-none focus:ring-2 focus:ring-purple-500 rounded-2xl px-3 py-1.5 text-5xl font-black leading-tight bg-gradient-to-br from-white to-slate-400 bg-clip-text text-transparent">
                Unlock Instant Access
            </h1>
            <p data-edit-field="subheadline" contenteditable="true" class="outline-none focus:ring-2 focus:ring-purple-500 rounded-2xl px-3 py-1.5 text-slate-400 text-xl font-medium leading-relaxed">
                Enter your best email address below to secure your spot and redirect to the presentation.
            </p>
            <div class="pt-4">
                <div class="space-y-4 max-w-sm mx-auto">
                    <input type="email" placeholder="name@email.com" class="w-full bg-slate-900/50 border border-slate-700 px-8 py-5 rounded-2xl outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 transition-all text-white font-bold placeholder:text-slate-650" disabled>
                    <button class="w-full bg-gradient-to-r from-indigo-600 to-indigo-500 hover:from-indigo-500 hover:to-indigo-400 text-white font-black text-sm uppercase tracking-widest px-10 py-5 rounded-2xl transition shadow-xl shadow-indigo-600/20 transform active:scale-95">
                        <span data-edit-field="ctaText" contenteditable="true" class="outline-none focus:ring-2 focus:ring-purple-500 rounded px-2">Get Instant Access</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</body>
</html>`,
  'quiz': `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0">
    <script src="https://cdn.tailwindcss.com"></script>
    <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;700;900&display=swap" rel="stylesheet">
    <style>
      body { font-family: 'Outfit', sans-serif; }
      .quiz-option.active { border-color: #a78bfa; background-color: rgba(167, 139, 250, 0.1); }
      [contenteditable="true"] { outline: none; cursor: text; transition: box-shadow 0.15s; }
      [contenteditable="true"]:hover { box-shadow: 0 0 0 2px rgba(168,85,247,0.4); border-radius: 8px; }
      [contenteditable="true"]:focus { box-shadow: 0 0 0 2px rgba(168,85,247,0.9); border-radius: 8px; }
    </style>
</head>
<body class="bg-slate-955 text-slate-300 min-h-screen flex flex-col items-center justify-center p-6 bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-indigo-900/10 via-slate-950 to-black font-sans">
    <div class="max-w-xl w-full bg-slate-900/60 border border-slate-800 rounded-[2.5rem] p-8 sm:p-10 space-y-8 shadow-2xl relative overflow-hidden backdrop-blur-md">
        <div class="absolute inset-0 bg-gradient-to-br from-indigo-900/10 via-transparent to-transparent opacity-50"></div>
        <div class="relative z-10 space-y-6">
            <div class="text-center space-y-2">
                <div class="inline-flex items-center px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-black uppercase tracking-[0.2em]">
                    Interactive Survey
                </div>
                <h1 data-edit-field="headline" contenteditable="true" class="text-3xl sm:text-4xl font-black text-white tracking-tight leading-tight">
                    Quick Quiz: Find Out If You Qualify
                </h1>
            </div>

            <div class="w-full bg-slate-800 rounded-full h-1.5 overflow-hidden">
                <div class="bg-indigo-500 h-full w-1/3 transition-all duration-500" id="progress-bar"></div>
            </div>

            <div class="space-y-4">
                <h2 data-edit-field="question" contenteditable="true" class="text-lg font-bold text-white text-center">
                    What is your primary fitness goal?
                </h2>
                
                <div class="grid grid-cols-1 gap-3 pt-2">
                    <button class="quiz-option w-full text-left p-4 rounded-2xl border border-slate-800 bg-slate-950/40 hover:border-slate-700 transition-all flex items-center justify-between text-sm font-semibold text-slate-300">
                        <span data-edit-field="option1" contenteditable="true" class="px-2">Lose weight and burn fat</span>
                        <div class="size-4 rounded-full border border-slate-700 flex items-center justify-center"><div class="size-2 rounded-full bg-transparent"></div></div>
                    </button>
                    <button class="quiz-option w-full text-left p-4 rounded-2xl border border-slate-800 bg-slate-950/40 hover:border-slate-700 transition-all flex items-center justify-between text-sm font-semibold text-slate-300">
                        <span data-edit-field="option2" contenteditable="true" class="px-2">Boost energy levels</span>
                        <div class="size-4 rounded-full border border-slate-700 flex items-center justify-center"><div class="size-2 rounded-full bg-transparent"></div></div>
                    </button>
                    <button class="quiz-option w-full text-left p-4 rounded-2xl border border-slate-800 bg-slate-950/40 hover:border-slate-700 transition-all flex items-center justify-between text-sm font-semibold text-slate-300">
                        <span data-edit-field="option3" contenteditable="true" class="px-2">Build long-term health</span>
                        <div class="size-4 rounded-full border border-slate-700 flex items-center justify-center"><div class="size-2 rounded-full bg-transparent"></div></div>
                    </button>
                </div>
            </div>

            <div class="text-center pt-4">
                <a href="{affiliate_link}" class="w-full inline-flex items-center justify-center bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-extrabold text-base sm:text-lg px-8 py-4.5 rounded-2xl shadow-xl shadow-indigo-600/20 transition hover:-translate-y-0.5 active:translate-y-0 active:scale-95 duration-200">
                    <span data-edit-field="ctaText" contenteditable="true" class="px-2">Submit & See If I Qualify →</span>
                </a>
            </div>
        </div>
    </div>
</body></html>`,

  'bridge': `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0">
    <script src="https://cdn.tailwindcss.com"></script>
    <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;700;900&display=swap" rel="stylesheet">
    <style>
      body { font-family: 'Outfit', sans-serif; }
      [contenteditable="true"] { outline: none; cursor: text; transition: box-shadow 0.15s; }
      [contenteditable="true"]:hover { box-shadow: 0 0 0 2px rgba(168,85,247,0.4); border-radius: 8px; }
      [contenteditable="true"]:focus { box-shadow: 0 0 0 2px rgba(168,85,247,0.9); border-radius: 8px; }
    </style>
</head>
<body class="bg-slate-955 text-slate-300 min-h-screen flex flex-col items-center justify-center p-6 bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-indigo-900/10 via-slate-950 to-black font-sans">
    <div class="max-w-2xl w-full bg-slate-900/60 border border-slate-800 rounded-[2.5rem] p-8 sm:p-10 space-y-8 shadow-2xl relative overflow-hidden backdrop-blur-md">
        <div class="absolute inset-0 bg-gradient-to-br from-indigo-900/10 via-transparent to-transparent opacity-50"></div>
        <div class="relative z-10 space-y-6 text-center">
            <div class="inline-flex items-center px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-black uppercase tracking-[0.2em]">
                Recommended Option
            </div>
            <h1 data-edit-field="headline" contenteditable="true" class="text-3xl sm:text-4xl font-black text-white tracking-tight leading-tight">
                Why We Recommend This Special Solution
            </h1>
            <p data-edit-field="subheadline" contenteditable="true" class="text-slate-400 text-base sm:text-lg leading-relaxed">
                We analyzed over 50 different alternatives. This is the only one that met our criteria for performance, speed, and overall value.
            </p>
            <div class="bg-slate-950/40 border border-slate-800 rounded-2xl p-6 text-left space-y-4">
                <div class="flex items-start gap-3">
                    <div class="size-5 rounded-full bg-indigo-500/20 flex items-center justify-center text-indigo-400 text-xs shrink-0 mt-0.5">✓</div>
                    <p class="text-sm text-slate-300 font-semibold">Scientifically formulated and clinically validated</p>
                </div>
                <div class="flex items-start gap-3">
                    <div class="size-5 rounded-full bg-indigo-500/20 flex items-center justify-center text-indigo-400 text-xs shrink-0 mt-0.5">✓</div>
                    <p class="text-sm text-slate-300 font-semibold">100% money-back guarantee for risk-free testing</p>
                </div>
                <div class="flex items-start gap-3">
                    <div class="size-5 rounded-full bg-indigo-500/20 flex items-center justify-center text-indigo-400 text-xs shrink-0 mt-0.5">✓</div>
                    <p class="text-sm text-slate-300 font-semibold">Rated 4.9/5 by verified customers globally</p>
                </div>
            </div>
            <div class="pt-4">
                <a href="{affiliate_link}" class="w-full inline-flex items-center justify-center bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-extrabold text-base sm:text-lg px-8 py-4.5 rounded-2xl shadow-xl shadow-indigo-600/20 transition hover:-translate-y-0.5 active:translate-y-0 active:scale-95 duration-200">
                    <span data-edit-field="ctaText" contenteditable="true" class="px-2">Continue to Official Offer →</span>
                </a>
            </div>
        </div>
    </div>
</body></html>`
};

const getTemplateByType = (type) => {
  const t = (type || '').toLowerCase();
  if (t.startsWith('quiz')) return DEFAULT_HTML_TEMPLATES['quiz'];
  if (t.startsWith('bridge')) return DEFAULT_HTML_TEMPLATES['bridge'];
  if (t === 'landing' || t === 'squeeze' || t === 'main') return DEFAULT_HTML_TEMPLATES['landing'];
  if (t === 'video-hub' || t === 'training') return DEFAULT_HTML_TEMPLATES['video-hub'];
  if (t.startsWith('adv') || t === 'advertorial') return DEFAULT_HTML_TEMPLATES['advertorial'];
  if (t === 'listicle') return DEFAULT_HTML_TEMPLATES['listicle'];
  if (t === 'capture-popup' || t === 'capture') return DEFAULT_HTML_TEMPLATES['capture-popup'];
  return DEFAULT_HTML_TEMPLATES['landing'];
};

const DEFAULT_OFFERS = [
  { id: 'o1', name: 'SoFi Invest', epc: '$2.45', conv: '12.4%', desc: 'Get up to $1,000 in free stock when you fund a new account.' },
  { id: 'o2', name: 'Robinhood', epc: '$1.98', conv: '10.2%', desc: 'Commission-free stock, ETF, and options trading.' },
  { id: 'o3', name: 'Acorns', epc: '$1.54', conv: '8.8%', desc: 'Round up spare change and invest it automatically.' },
];

const DEFAULT_LESSONS = [
  { id: 'l1', title: 'Intro to Affiliate Marketing', dur: '8m 20s', done: true },
  { id: 'l2', title: 'Finding Hot Offers', dur: '12m 14s', active: true },
  { id: 'l3', title: 'Traffic Secrets', dur: '9m 45s' },
  { id: 'l4', title: 'Scale to $1k/Day', dur: '15m 02s' },
];

const defaultCourseData = {
  sections: [
    {
      title: "Module 01: Setup & Foundations",
      lessons: [
        { title: "Welcome & System Tour", videoUrl: "https://firebasestorage.googleapis.com/v0/b/affiliate-ninja-app-2026.firebasestorage.app/o/VSL%2FBecome-an-Affiliate-Ninja.mp4?alt=media&token=b5dcb15b-5ff4-41fe-9c35-a121350a03d4", dur: "4m 12s", desc: "A complete walkthrough of the Affiliate Flow AI platform and dashboard." },
        { title: "Choosing High-EPC Offers", videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4", dur: "8m 45s", desc: "How to browse JVZoo and Clickbank to locate offers with premium conversion rates." }
      ]
    },
    {
      title: "Module 02: Launching Traffic",
      lessons: [
        { title: "Native Ads Direct Routing", videoUrl: "https://www.w3schools.com/html/movie.mp4", dur: "11m 30s", desc: "Setting up your campaigns to forward traffic straight to your squeeze and OTO pages." }
      ]
    }
  ]
};

/* â”€â”€â”€ High-Fidelity Static Mockup Templates (Only used as fallback) â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const InteractiveMockup = ({ node, pageContent = {}, onUpdate, onAskAI }) => {
  const t = node.type;
  const pc = pageContent;

  const handleUpdate = (field, val) => {
    onUpdate(field, val);
  };

  const heroImage = pc.image || DEFAULT_IMAGES[0];
  const ctaColor = pc.ctaColor || C.orange;

  /* Fallback template for Advertorial */
  if (t === 'adv-a' || t === 'adv-b') return (
    <div className="bg-slate-950 text-slate-350 min-h-screen font-sans antialiased pb-16 px-6">
      <div className="max-w-2xl mx-auto py-10 space-y-6 text-left">
        <span className="text-[9px] font-black text-indigo-400 uppercase tracking-widest border border-indigo-500/30 bg-indigo-500/10 px-3 py-1 rounded-full">SPONSORED EDITORIAL</span>
        <h1 className="text-3xl sm:text-5xl font-black text-white leading-tight">{pc.headline || 'Write a compelling advertorial headline...'}</h1>
        <p className="text-slate-400 border-l-4 border-indigo-500 pl-4 py-1">{pc.subheadline || 'Subheadline explaining the editorial hook...'}</p>
        <div className="aspect-video bg-slate-900 rounded-3xl overflow-hidden border border-slate-800 flex items-center justify-center">
          {heroImage ? <img src={heroImage} className="w-full h-full object-cover" alt="Hero" /> : 'ðŸ–¼ï¸'}
        </div>
        <p className="text-slate-300 leading-[1.8] whitespace-pre-line">{pc.body || 'Pre-sell body content goes here...'}</p>
        <div className="pt-6 text-center">
          <button className="px-10 py-4 text-white font-black text-lg rounded-2xl" style={{ background: ctaColor }}>
            {pc.ctaText || 'Claim Your Deal Now â†’'}
          </button>
        </div>
      </div>
    </div>
  );

  /* Fallback template for Landing page */
  if (t === 'landing') return (
    <div className="bg-slate-955 text-slate-300 min-h-screen pb-20 pt-10 px-4 bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-indigo-900/10 via-slate-950 to-black font-sans flex flex-col items-center justify-between text-center">
      <div className="max-w-2xl w-full mx-auto space-y-6">
        <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[9px] font-black uppercase tracking-[0.2em] mx-auto select-none">
          â˜… SPECIAL PARTNER TRAINING â˜…
        </div>
        <h1 className="text-3xl sm:text-5xl font-black text-white tracking-tighter leading-tight bg-gradient-to-b from-white to-slate-400 bg-clip-text text-transparent">
          {pc.headline || 'Free Affiliate Marketing Course'}
        </h1>
        <p className="text-slate-400 text-xs sm:text-sm max-w-xl mx-auto leading-relaxed">
          {pc.subheadline || 'Discover the exact systematic routing designed to automate your campaigns.'}
        </p>
        <div className="bg-slate-900/45 border border-slate-800 rounded-[2.5rem] p-6 sm:p-8 space-y-6 shadow-2xl relative overflow-hidden mt-6">
          <div className="aspect-video w-full bg-slate-950 rounded-[2rem] border border-slate-850 flex items-center justify-center relative">
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/20 to-purple-900/20"></div>
            <div className="relative z-10 text-center space-y-4">
              <div className="w-20 h-20 bg-white/5 rounded-full flex items-center justify-center mx-auto border border-white/10">
                <Play size={28} className="text-white/40 ml-1" fill="currentColor" />
              </div>
              <p className="text-slate-500 font-bold text-xs uppercase tracking-widest">Video Coming Soon</p>
            </div>
          </div>
          <div className="pt-2 flex flex-col items-center">
            <button className="w-full max-w-sm py-4 text-white font-black text-lg rounded-2xl shadow-xl" style={{ background: `linear-gradient(135deg, ${C.purple}, ${C.violet})` }}>
              {pc.ctaText || 'Subscribe Free'}
            </button>
            <p className="text-[10px] text-slate-500 uppercase tracking-widest font-black mt-3">100% Free Access â€¢ Instant Registration</p>
          </div>
        </div>
      </div>
    </div>
  );

  /* Fallback template for Listicle */
  if (t === 'listicle') {
    const offers = node.offers || DEFAULT_OFFERS;
    return (
      <div className="bg-slate-950 text-slate-300 min-h-screen pb-20 pt-10 px-4 bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-indigo-900/10 via-slate-950 to-black font-sans antialiased text-center">
        <div className="max-w-2xl mx-auto space-y-6">
          <span className="inline-flex items-center px-3.5 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[9px] font-black uppercase tracking-widest">â˜… RECOMMENDED OFFERS â˜…</span>
          <h1 className="text-3xl sm:text-5xl font-black text-white leading-none">{pc.headline || 'Top Reviewed Products'}</h1>
          <p className="text-slate-400 text-sm">{pc.subheadline || 'Compare the best options available.'}</p>
          <div className="space-y-4 pt-6 text-left">
            {offers.map((offer, idx) => (
              <div key={offer.id || idx} className="bg-slate-900 border border-slate-800 p-6 rounded-2xl flex items-center justify-between gap-4">
                <div className="flex items-center space-x-4">
                  <span className="text-lg font-black text-indigo-400">#{idx+1}</span>
                  <div>
                    <h4 className="text-white font-bold text-sm">{offer?.name || ''}</h4>
                    <p className="text-xs text-slate-400">{offer?.desc || ''}</p>
                  </div>
                </div>
                <button className="px-4 py-2 bg-indigo-600 text-white text-[10px] font-black rounded-lg uppercase">Link â†’</button>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  /* Fallback template for Video Hub */
  if (t === 'video-hub') {
    const lessons = node.lessons || DEFAULT_LESSONS;
    return (
      <div className="bg-slate-950 text-white min-h-screen py-12 px-6 bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-indigo-900/20 via-slate-950 to-black font-sans text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          <span className="text-indigo-400 font-black text-xs uppercase tracking-widest">Module 01 â€¢ Course Hub</span>
          <h1 className="text-4xl sm:text-5xl font-black text-white">{pc.headline || 'The AI Blueprint'}</h1>
          <p className="text-slate-400 text-sm max-w-xl mx-auto">{pc.description || 'Watch the modules below.'}</p>
          <div className="aspect-video w-full max-w-2xl mx-auto bg-slate-900 border border-slate-800 rounded-3xl flex items-center justify-center">
            <Play size={32} fill="#fff" />
          </div>
        </div>
      </div>
    );
  }

  /* Fallback template for Capture Popup */
  if (t === 'capture-popup' || t === 'capture') return (
    <div className="bg-[#020617] text-white min-h-screen flex items-center justify-center p-6 font-sans">
      <div className="max-w-md w-full text-center space-y-6 bg-[#0f172a] p-10 rounded-[2rem] border border-slate-800 shadow-2xl relative overflow-hidden">
        <div className="absolute -top-16 -left-16 w-32 h-32 bg-indigo-600/10 rounded-full blur-2xl"></div>
        <div className="relative z-10 space-y-4">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[9px] font-black uppercase tracking-[0.2em]">
            Exclusive Access
          </span>
          <h1 className="text-3xl font-black leading-tight bg-gradient-to-br from-white to-slate-400 bg-clip-text text-transparent">
            {pc.headline || 'Unlock Instant Access'}
          </h1>
          <p className="text-slate-400 text-sm leading-relaxed">
            {pc.subheadline || 'Enter your best email address below to secure your spot and redirect to the presentation.'}
          </p>
          <div className="pt-2">
            <div className="space-y-3 max-w-xs mx-auto">
              <input type="email" placeholder={pc.inputPlaceholder || 'name@email.com'} className="w-full bg-slate-900/50 border border-slate-700 px-4 py-3 rounded-xl outline-none focus:border-indigo-500 text-white font-bold text-xs placeholder:text-slate-650" disabled />
              <button className="w-full bg-gradient-to-r from-indigo-600 to-indigo-500 text-white font-black text-xs uppercase tracking-widest px-6 py-3 rounded-xl">
                {pc.ctaText || 'Get Instant Access'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-slate-950 text-slate-400 h-full flex flex-col items-center justify-center p-6 text-center select-none space-y-2">
      <Globe size={32} className="text-slate-700 animate-pulse" />
      <span className="text-xs font-black uppercase tracking-widest">Visual Page Preview Node</span>
      <span className="text-[10px] text-slate-600 font-medium">Use the "Edit Fields" tab to modify page assets.</span>
    </div>
  );
};

const TrafficConfigurator = ({ node, campaignData, onUpdateNode }) => {
  const pc = node.pageContent || {};
  const label = (node.label || '').toLowerCase();
  const isCustomNode = label.includes('custom');

  // Average market CPC by network (used as smart default when user hasn't set one)
  const DEFAULT_CPC_BY_SOURCE = {
    googleads:  1.20,  // Google Search Ads — high intent, competitive
    bingads:    0.75,  // Bing/Microsoft Ads — slightly cheaper than Google
    facebook:   0.65,  // Facebook / Meta — broad audience CPCs
    instagram:  0.70,  // Instagram Ads
    tiktok:     0.55,  // TikTok Ads — growing but still cheaper
    taboola:    0.35,  // Native (Taboola) — content discovery CPCs
    outbrain:   0.30,  // Native (Outbrain)
    mgid:       0.25,  // Native (MGID) — budget-friendly native
    propeller:  0.008, // PropellerAds push/pop (CPM-style, very low per-click)
    richpush:   0.010, // RichPush push notifications
    adcash:     0.012, // Adcash push/pop
    email:      0.45,  // Solo ads / email newsletters
    seo:        0.00,  // Organic SEO — no cost per click
    direct:     0.00,  // Direct / unknown
    custom:     0.00,  // Custom / Partner Hub nodes — always $0 default
  };

  let autoSrc = 'direct';
  if (label.includes('google')) autoSrc = 'googleads';
  else if (label.includes('bing')) autoSrc = 'bingads';
  else if (label.includes('facebook') || label.includes('meta')) autoSrc = 'facebook';
  else if (label.includes('instagram')) autoSrc = 'instagram';
  else if (label.includes('tiktok')) autoSrc = 'tiktok';
  else if (label.includes('taboola')) autoSrc = 'taboola';
  else if (label.includes('outbrain')) autoSrc = 'outbrain';
  else if (label.includes('mgid')) autoSrc = 'mgid';
  else if (label.includes('propeller')) autoSrc = 'propeller';
  else if (label.includes('richpush') || label.includes('rich push')) autoSrc = 'richpush';
  else if (label.includes('adcash')) autoSrc = 'adcash';
  else if (label.includes('push') || label.includes('pop')) autoSrc = 'propeller';
  else if (label.includes('email') || label.includes('solo')) autoSrc = 'email';
  else if (label.includes('seo') || label.includes('organic')) autoSrc = 'seo';
  else if (label.includes('youtube') || label.includes('video')) autoSrc = 'facebook'; // CPV is similar range
  else { autoSrc = pc.customSource || 'custom'; }

  // Smart CPC default: use stored value if set, else look up by source, else 0
  const resolvedSrc = isCustomNode ? (pc.customSource || 'custom') : autoSrc;
  const defaultCpc = DEFAULT_CPC_BY_SOURCE[resolvedSrc] ?? 0.00;

  const currentSrcVal = isCustomNode ? (pc.customSource || 'custom') : autoSrc;
  const [copied, setCopied] = useState(false);

  const username = campaignData?.username || 'user';
  const slug = campaignData?.slug || 'page';
  const generatedUrl = `${window.location.origin}/u/${username}/${slug}?source=${currentSrcVal}`;

  const handleCustomValChange = (val) => {
    onUpdateNode(node.id, {
      pageContent: {
        ...pc,
        customSource: val.replace(/[^a-zA-Z0-9_-]/g, '') // sanitize
      }
    });
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(generatedUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Traffic breakdown computations
  const totalClicks = campaignData?.clicks || 0;
  const sources = campaignData?.sources || {};

  const SOURCE_STYLES = {
    googleads: { label: 'Google Ads', gradient: 'from-blue-500 to-indigo-650', icon: '🔍' },
    facebook: { label: 'Facebook Ads', gradient: 'from-indigo-600 to-blue-700', icon: '👥' },
    tiktok: { label: 'TikTok Ads', gradient: 'from-rose-500 via-purple-500 to-cyan-500', icon: '🎵' },
    bingads: { label: 'Bing Ads', gradient: 'from-emerald-500 to-teal-650', icon: '💻' },
    taboola: { label: 'Taboola', gradient: 'from-orange-500 to-red-600', icon: '📰' },
    outbrain: { label: 'Outbrain', gradient: 'from-amber-500 to-orange-600', icon: '🧠' },
    email: { label: 'Email Campaigns', gradient: 'from-purple-500 to-pink-500', icon: '✉️' },
    seo: { label: 'SEO / Organic', gradient: 'from-emerald-400 to-green-600', icon: '🌱' },
    direct: { label: 'Direct / Other', gradient: 'from-slate-400 to-slate-600', icon: '🚪' }
  };

  const getSourceStyle = (key) => {
    const k = key.toLowerCase();
    if (SOURCE_STYLES[k]) return SOURCE_STYLES[k];
    const gradients = [
      'from-violet-500 to-purple-650',
      'from-pink-500 to-rose-600',
      'from-cyan-500 to-blue-600',
      'from-amber-500 to-yellow-600',
      'from-teal-500 to-emerald-600'
    ];
    let hash = 0;
    for (let i = 0; i < k.length; i++) {
      hash = k.charCodeAt(i) + ((hash << 5) - hash);
    }
    const gradient = gradients[Math.abs(hash) % gradients.length];
    return {
      label: key.charAt(0).toUpperCase() + key.slice(1),
      gradient,
      icon: '🔗'
    };
  };

  return (
    <div className="max-w-5xl w-full grid grid-cols-1 md:grid-cols-2 gap-8 bg-slate-900/60 border border-slate-800/80 p-8 sm:p-10 rounded-[2.5rem] shadow-2xl relative overflow-hidden text-left select-text">
      <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/5 rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none"></div>
      
      {/* Left Column: Configurator Settings */}
      <div className="space-y-6 flex flex-col justify-between">
        <div className="space-y-6">
          <div className="space-y-2">
            <div className="inline-flex items-center gap-1.5 px-3.5 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-[10px] font-black uppercase tracking-[0.25em]">
              <span className="size-1.5 bg-emerald-400 rounded-full animate-ping" />
              Traffic Source Configurator
            </div>
            <h3 className="text-2xl font-black text-white tracking-tight leading-none mt-2">{node.title || 'Traffic Source'}</h3>
            <p className="text-slate-400 text-xs leading-relaxed max-w-xl">
              Track entry links and count clicks specifically for this marketing campaigns.
            </p>
          </div>

          {!isCustomNode ? (
            <div className="p-6 bg-slate-950/50 border border-slate-850/60 rounded-2xl space-y-2.5">
              <div className="flex items-center space-x-2 text-indigo-400">
                <span className="text-sm">🎯</span>
                <span className="text-xs font-black uppercase tracking-wider">Automated Parameter Enabled</span>
              </div>
              <p className="text-[11px] text-slate-400 leading-relaxed">
                Because this is a dedicated <strong>{node.label}</strong> node, the tracking parameter <code className="text-indigo-400 font-bold bg-indigo-500/10 px-1.5 py-0.5 rounded">?source={autoSrc}</code> is automatically managed and active.
              </p>
            </div>
          ) : (
            <div className="p-6 bg-slate-950/50 border border-slate-800 rounded-2xl space-y-2.5 animate-in fade-in duration-200">
              <label className="text-[9px] font-black text-slate-500 uppercase tracking-widest block font-sans">Custom Tracking Source Parameter</label>
              <div className="flex items-center gap-3">
                <span className="text-xs text-slate-655 font-bold font-mono">?source=</span>
                <input
                  type="text"
                  value={pc.customSource || ''}
                  onChange={(e) => handleCustomValChange(e.target.value)}
                  placeholder="e.g. newsletter_june"
                  className="flex-1 bg-slate-950 border border-slate-850 text-white font-mono text-xs px-4 py-3 rounded-xl focus:border-indigo-500 outline-none transition-all placeholder:text-slate-800"
                />
              </div>
              <p className="text-[9px] text-slate-600 leading-normal">Only alphanumeric characters, dashes, and underscores are allowed. Spaces are removed automatically.</p>
            </div>
          )}

          {/* CPC configuration field */}
          <div className="p-6 bg-slate-950/50 border border-slate-850/60 rounded-2xl space-y-2.5">
            <label className="text-[9px] font-black text-slate-550 uppercase tracking-widest block font-sans">Ad Network Cost Configuration</label>
            <div className="flex items-center gap-3">
              <span className="text-xs text-slate-400 font-bold">Avg Cost Per Click (CPC):</span>
              <div className="relative flex-1">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3.5 text-slate-500 text-xs">$</span>
                <input
                  type="number"
                  step="0.001"
                  min="0"
                  value={pc.cpc !== undefined ? pc.cpc : defaultCpc}
                  onChange={(e) => {
                    onUpdateNode(node.id, {
                      pageContent: {
                        ...pc,
                        cpc: parseFloat(e.target.value) || 0
                      }
                    });
                  }}
                  placeholder={defaultCpc.toString()}
                  className="w-full bg-slate-950 border border-slate-850 text-white font-mono text-xs pl-7 pr-4 py-3 rounded-xl focus:border-indigo-500 outline-none transition-all"
                />
              </div>
            </div>
            <p className="text-[9px] text-slate-600 leading-normal">Used to calculate Total Spend, ROI, and average EPC stats in real-time.</p>
          </div>
        </div>

        {/* Generated Link Display */}
        <div className="p-6 sm:p-7 rounded-[2rem] bg-indigo-500/[0.02] border border-indigo-500/10 flex flex-col space-y-4">
          <label className="text-[10px] font-black text-indigo-400 uppercase tracking-[0.2em] block">Your Trackable Funnel Landing Link</label>
          <div className="flex flex-col gap-3">
            <div className="bg-slate-950 border border-slate-850 rounded-2xl px-4 py-4 font-mono text-[11px] text-slate-350 truncate select-all flex items-center shadow-inner">
              <LinkIcon size={12} className="mr-2 text-indigo-500 shrink-0" />
              <span className="truncate">{generatedUrl}</span>
            </div>
            <button
              onClick={handleCopy}
              className={`w-full py-4 rounded-2xl font-black text-xs uppercase tracking-widest transition-all duration-200 active:scale-95 flex items-center justify-center gap-2 shrink-0 ${
                copied 
                  ? 'bg-emerald-600 text-white shadow-lg shadow-emerald-500/20' 
                  : 'bg-indigo-600 hover:bg-indigo-500 text-white shadow-lg shadow-indigo-500/25'
              }`}
            >
              {copied ? (
                <>
                  <Check size={14} className="shrink-0" />
                  <span>Copied!</span>
                </>
              ) : (
                <>
                  <Copy size={14} className="shrink-0" />
                  <span>Copy Tracking Link</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Right Column: Traffic Analytics Dashboard */}
      <div className="border-t md:border-t-0 md:border-l border-slate-800/80 pt-6 md:pt-0 md:pl-8 space-y-6 flex flex-col justify-between">
        <div className="space-y-4">
          <div className="space-y-1">
            <div className="text-[10px] font-black text-slate-500 uppercase tracking-widest">Live Campaign Metrics</div>
            <h4 className="text-lg font-black text-white">Traffic Source Analytics</h4>
          </div>

          <div className="grid grid-cols-2 gap-4 bg-slate-950/40 p-4 border border-slate-850/60 rounded-2xl">
            <div>
              <span className="text-[9px] font-black text-slate-500 uppercase tracking-widest block">Total Funnel Clicks</span>
              <span className="text-2xl font-black text-white">{totalClicks}</span>
            </div>
            <div>
              <span className="text-[9px] font-black text-slate-500 uppercase tracking-widest block">Active Channels</span>
              <span className="text-2xl font-black text-white">{Object.keys(sources).length}</span>
            </div>
          </div>
        </div>

        <div className="flex-1 min-h-[200px] flex flex-col justify-center">
          {Object.keys(sources).length === 0 ? (
            <div className="text-center py-8 space-y-3">
              <div className="w-12 h-12 rounded-full bg-slate-950 flex items-center justify-center mx-auto border border-slate-850/60">
                <span className="text-lg animate-pulse">📡</span>
              </div>
              <div className="space-y-1">
                <h5 className="text-xs font-black text-slate-400 uppercase tracking-wider">Awaiting Traffic Data</h5>
                <p className="text-[10px] text-slate-600 max-w-[240px] mx-auto leading-normal">
                  Promote your tracking link. Clicks from Facebook, Google Ads, or custom sources will instantly register here.
                </p>
              </div>
            </div>
          ) : (
            <div className="space-y-5 max-h-[300px] overflow-y-auto pr-1 custom-scrollbar">
              {Object.entries(sources)
                .sort((a, b) => b[1] - a[1])
                .map(([key, count]) => {
                  const pct = totalClicks > 0 ? ((count / totalClicks) * 100).toFixed(1) : 0;
                  const style = getSourceStyle(key);
                  
                  // Financial stats calculations
                  const conversionsBySource = campaignData?.conversionsBySource || {};
                  const revenueBySource = campaignData?.revenueBySource || {};
                  const convs = conversionsBySource[key] || conversionsBySource[key.toLowerCase()] || 0;
                  const convRate = count > 0 ? ((convs / count) * 100).toFixed(1) : '0.0';
                  
                  const cpc = pc.cpc !== undefined ? pc.cpc : 0.18;
                  const spend = count * cpc;
                  const revenue = revenueBySource[key] || revenueBySource[key.toLowerCase()] || 0;
                  const epc = count > 0 ? (revenue / count).toFixed(2) : '0.00';
                  const roiVal = spend > 0 ? ((revenue - spend) / spend) * 100 : 0;
                  const roi = roiVal.toFixed(0);

                  return (
                    <div key={key} className="space-y-2 border-b border-slate-850/40 pb-3 last:border-0 last:pb-0">
                      <div className="flex justify-between items-center text-[11px] font-bold">
                        <span className="text-white flex items-center gap-1.5">
                          <span className="text-sm">{style.icon}</span>
                          <span>{style.label}</span>
                          <span className="text-[9px] text-slate-500 font-mono bg-slate-950 px-1.5 py-0.5 rounded">?source={key}</span>
                        </span>
                        <span className="text-slate-450 font-mono">{count} clicks · <span className="text-emerald-450">{convs} sales</span> <span className="text-slate-600">({convRate}%)</span></span>
                      </div>
                      <div className="h-2 bg-slate-950 rounded-full overflow-hidden border border-slate-850/60 p-[1px]">
                        <div 
                          className={`h-full rounded-full bg-gradient-to-r ${style.gradient} transition-all duration-500`}
                          style={{ width: `${pct}%` }}
                        />
                      </div>
                      <div className="flex justify-between items-center text-[9.5px] text-slate-500 font-mono font-medium px-0.5">
                        <span>Spend: <strong className="text-slate-400">${spend.toFixed(2)}</strong></span>
                        <span>Rev: <strong className="text-slate-400">${revenue.toFixed(2)}</strong></span>
                        <span>EPC: <strong className="text-indigo-400">${epc}</strong></span>
                        <span>ROI: <strong className={roiVal >= 0 ? "text-emerald-400 font-bold" : "text-rose-450 font-bold"}>{roiVal >= 0 ? `+${roi}%` : `${roi}%`}</strong></span>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
        
        <div className="text-[9px] font-bold text-slate-600 uppercase tracking-wider flex items-center justify-center gap-1.5 border-t border-slate-850/40 pt-4">
          <span className="size-1.5 bg-emerald-500 rounded-full animate-pulse" />
          <span>Real-time conversion routing stats</span>
        </div>
      </div>
    </div>
  );
};

/* ─── Main Visual Page Editor Overlay Component ───────────────────────────── */
const VisualPageEditor = ({ 
  nodeId, 
  nodes, 
  onClose, 
  onUpdateNode, 
  campaignData, 
  localPages = {},
  isPartnerHub,
  isInline = false,
  glowField: propGlowField = null,
  onBuildPage = null
}) => {
  const node = useMemo(() => nodes.find(n => n.id === nodeId), [nodes, nodeId]);
  if (!node) return null;

  const isPageBuilt = useMemo(() => {
    if (!campaignData) return false;
    const angleId = node.data?.angleId;
    const directPages = campaignData.pages || {};
    const local = localPages || {};
    return Boolean(
      (angleId && directPages[`page_${angleId}`]) ||
      directPages[`page_${node.id}`] ||
      directPages[node.id] ||
      (angleId && directPages[angleId]) ||
      (angleId && local[`page_${angleId}`]) ||
      local[`page_${node.id}`] ||
      local[node.id] ||
      (angleId && local[angleId])
    );
  }, [campaignData, localPages, node]);

  const pc = useMemo(() => node.pageContent || {}, [node]);
  const [activeTab, setActiveTab] = useState(node?.type === 'capture-popup' ? 'connection' : 'coach'); // 'connection' | 'coach'
  const [previewDevice, setPreviewDevice] = useState('desktop');
  const [showPopupOverlay, setShowPopupOverlay] = useState(false);
  const [profile, setProfile] = useState(null);
  const [mailerXpLists, setMailerXpLists] = useState([]);
  const [mailerXpSegments, setMailerXpSegments] = useState([]);
  const [loadingMailerXp, setLoadingMailerXp] = useState(false);
  const [mailerXpError, setMailerXpError] = useState(null);
  const [showAutoresponder, setShowAutoresponder] = useState(node.type === 'capture-popup');
  const [inlineApiKey, setInlineApiKey] = useState('');
  const [savingApiKey, setSavingApiKey] = useState(false);
  const [showCreateList, setShowCreateList] = useState(false);
  const [newListName, setNewListName] = useState('');
  const [creatingList, setCreatingList] = useState(false);
  const [createListError, setCreateListError] = useState(null);

  const captureNode = useMemo(() => {
    return nodes.find(n => n.type === 'capture-popup');
  }, [nodes]);

  const initialCustomForm = pc.customForm || captureNode?.pageContent?.customForm || null;
  const initialIsCustom = (pc.autoresponderProvider || captureNode?.pageContent?.autoresponderProvider) === 'custom_html' || !!initialCustomForm;
  
  const [arTab, setArTab] = useState(initialIsCustom ? 'custom_html' : 'mailerxp');
  const [customFormError, setCustomFormError] = useState(null);
  const [rawFormInput, setRawFormInput] = useState(initialCustomForm?.rawHtml || '');

  const connectedListId = pc.mailerXpList || captureNode?.pageContent?.mailerXpList || campaignData?.mailerXpList;
  const isMailerXpConnected = !!connectedListId;
  const connectedListName = useMemo(() => {
    if (!connectedListId) return '';
    return mailerXpLists.find(l => (l.id || l.uid) === connectedListId)?.name || 'Connected List';
  }, [connectedListId, mailerXpLists]);

  const hasOptinForm = useMemo(() => {
    if (!campaignData) return false;
    const directPages = campaignData.pages || {};
    const local = localPages || {};
    const angleId = node.data?.angleId;
    const html = (angleId ? local[`page_${angleId}`] : null) ||
                 local[`page_${node.id}`] ||
                 local[node.id] ||
                 (angleId ? directPages[`page_${angleId}`] : null) ||
                 directPages[`page_${node.id}`] ||
                 directPages[node.id] || '';
    if (!html || typeof html !== 'string') return false;
    return (
      html.includes('type="email"') ||
      html.includes("type='email'") ||
      html.includes('fieldEmail') ||
      html.includes('handleFormSubmit') ||
      html.includes('<form')
    );
  }, [campaignData, localPages, node]);

  const updateCaptureField = (field, val) => {
    if (captureNode) {
      const newPc = { ...captureNode.pageContent };
      newPc[field] = val;
      if (field === 'subheadline') newPc.subtext = val;
      if (field === 'ctaText') newPc.btnText = val;
      onUpdateNode(captureNode.id, { pageContent: newPc });
    }
  };

  const handleParseVisualCustomForm = (html) => {
    setRawFormInput(html);
    if (!html || !html.trim()) {
      setCustomFormError(null);
      updateField('customForm', null);
      if (node.type === 'capture-popup') updateCaptureField('customForm', null);
      return;
    }
    const parsed = parseHtmlFormEmbed(html);
    if (parsed.error) {
      setCustomFormError(parsed.error);
    } else {
      setCustomFormError(null);
      updateField('customForm', parsed);
      updateField('autoresponderProvider', 'custom_html');
      if (node.type === 'capture-popup') {
        updateCaptureField('customForm', parsed);
        updateCaptureField('autoresponderProvider', 'custom_html');
      }
    }
  };

  const [chatMessages, setChatMessages] = useState([
    { 
      role: 'ai', 
      content: `Hello! I am your IA Coach. 

I've analyzed your campaign settings for "${campaignData?.name || 'this funnel'}". How can I help you improve the conversion rate of this ${node.type.toUpperCase()} page? 

Use the "Edit Fields" tab on the right to edit headlines, images, and buttons in real-time, or chat with me here to generate recommendations!` 
    }
  ]);
  const [chatInput, setChatInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [localGlowField, setLocalGlowField] = useState(null);
  const glowField = isInline ? propGlowField : localGlowField;
  const setGlowField = isInline ? () => {} : setLocalGlowField;
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatMessages]);

  const updateField = (field, val) => {
    const newPc = { ...pc, [field]: val };
    onUpdateNode(node.id, { pageContent: newPc });
  };

  /* compile HTML template dynamically in client from node config */
  const compiledHtml = useMemo(() => {
    if (!campaignData) return '';
    const variants = campaignData.pageVariants || [];
    const type = node.type.toLowerCase();

    const injectPreviewHelper = (rawHtml) => {
      if (!rawHtml) return rawHtml;
      const previewFormScript = `
        <script>
          window.handleFormSubmit = function(e) {
            if (e) {
              if (typeof e.preventDefault === 'function') e.preventDefault();
              if (typeof e.stopPropagation === 'function') e.stopPropagation();
            }
            var formOrContainer = (e && e.target) ? (e.target.closest('form') || e.target.closest('#entryForm') || e.target.closest('.optin-form') || document) : document;
            var emailInput = formOrContainer.querySelector('#fieldEmail') || formOrContainer.querySelector('input[type="email"]') || formOrContainer.querySelector('input[name="email"]') || document.querySelector('#fieldEmail') || document.querySelector('input[type="email"]');
            var email = emailInput ? emailInput.value.trim() : '';
            var entryForm = document.getElementById('entryForm') || (formOrContainer.tagName === 'FORM' ? formOrContainer : null);
            var formSuccess = document.getElementById('formSuccess') || document.querySelector('.form-success');

            if (formSuccess) {
              if (entryForm) entryForm.style.display = 'none';
              formSuccess.style.display = 'block';
              formSuccess.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              alert('✅ [Editor Preview]: Test opt-in captured' + (email ? ' for ' + email : '') + '! In live mode, leads sync directly to MailerXP.');
            }
            return false;
          };
        </script>
      `;
      const bodyClose = rawHtml.toLowerCase().lastIndexOf('</body>');
      if (bodyClose !== -1) {
        return rawHtml.substring(0, bodyClose) + previewFormScript + rawHtml.substring(bodyClose);
      }
      return rawHtml + previewFormScript;
    };

    // ── Priority 0 (highest): localPages from this session ──
    // These are pages built RIGHT NOW in this browser session.
    // localPages is proper React state so the useMemo dependency correctly detects changes.
    if (localPages && typeof localPages === 'object') {
      const angleId = node.data?.angleId;
      const sessionHtml = (angleId ? localPages[`page_${angleId}`] : null)
        || localPages[`page_${node.id}`]
        || (angleId ? localPages[angleId] : null)
        || localPages[node.id];
      if (sessionHtml && sessionHtml.length > 100) return injectPreviewHelper(sessionHtml);
    }

    // ── Priority 1: look directly in campaignData.pages (the map saved by Page Builder) ──
    // This covers cases where pageVariants may be empty but pages has the built HTML.
    if (campaignData.pages && typeof campaignData.pages === 'object') {
      const angleId = node.data?.angleId;
      const directHtml = (angleId ? campaignData.pages[`page_${angleId}`] : null)
        || campaignData.pages[`page_${node.id}`]
        || campaignData.pages[node.id]
        || (angleId ? campaignData.pages[angleId] : null);
      if (directHtml && directHtml.length > 100) return injectPreviewHelper(directHtml);
    }

    // ── Capture Popup Node: render as an open modal overlay on a dark bg ──
    if (type === 'capture-popup' || type === 'capture') {
      const headline = pc.headline || 'Unlock Instant Access';
      const subtext = pc.subheadline || pc.subtext || 'Enter your best email address below to secure your spot and redirect to the presentation.';
      const btnText = pc.ctaText || pc.btnText || 'Get Instant Access';
      const placeholder = pc.inputPlaceholder || 'name@email.com';
      return `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1.0">
<script src="https://cdn.tailwindcss.com"></script>
<link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;700;900&display=swap" rel="stylesheet">
<style>body{font-family:'Outfit',sans-serif;margin:0;padding:0;}[contenteditable="true"]{outline:none;cursor:text;transition:box-shadow .15s;}[contenteditable="true"]:hover{box-shadow:0 0 0 2px rgba(168,85,247,0.4);border-radius:8px;}[contenteditable="true"]:focus{box-shadow:0 0 0 2px rgba(168,85,247,0.9);border-radius:8px;}</style>
</head>
<body class="bg-slate-950 min-h-screen flex items-center justify-center p-6">
  <div class="fixed inset-0 bg-slate-950/90 backdrop-blur-sm flex items-center justify-center p-4">
    <div class="relative w-full max-w-lg bg-slate-900 border border-slate-800/80 text-white p-8 md:p-10 rounded-[2rem] shadow-2xl shadow-indigo-500/10 flex flex-col items-center text-center">
      <div class="w-16 h-16 bg-gradient-to-tr from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg shadow-indigo-500/25 mb-6">
        <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
      </div>
      <h2 data-edit-field="headline" data-node-type="capture-popup" contenteditable="true" class="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-white via-slate-100 to-slate-300 tracking-tight leading-tight mb-4 w-full">${headline}</h2>
      <p data-edit-field="subheadline" data-node-type="capture-popup" contenteditable="true" class="text-slate-400 text-base mb-8 leading-relaxed max-w-sm w-full">${subtext}</p>
      <div class="w-full space-y-4">
        <input type="email" placeholder="${placeholder}" class="w-full pl-4 pr-4 py-4 bg-slate-950/50 border border-slate-800 rounded-2xl text-white placeholder-slate-500 text-base" disabled>
        <button class="w-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white font-extrabold text-lg py-4 rounded-2xl shadow-lg shadow-indigo-500/25 flex items-center justify-center gap-3">
          <span data-edit-field="ctaText" data-node-type="capture-popup" contenteditable="true" class="px-2">${btnText}</span>
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
        </button>
      </div>
      <p class="text-sm text-slate-500 mt-6 flex items-center gap-2">
        <svg class="w-4 h-4 text-emerald-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg>
        We respect your privacy. Spam-free.
      </p>
      <div style="position:fixed;bottom:12px;left:50%;transform:translateX(-50%);background:rgba(99,102,241,0.15);border:1px solid rgba(99,102,241,0.3);color:#a5b4fc;padding:6px 16px;border-radius:999px;font-size:10px;font-weight:900;text-transform:uppercase;letter-spacing:.12em;pointer-events:none;">✏️ Click text above to edit</div>
    </div>
  </div>
  <script>
    document.querySelectorAll('[contenteditable="true"]').forEach(el => {
      el.addEventListener('input', () => {
        window.parent.postMessage({ type: 'content-update', isCapturePopup: true, field: el.getAttribute('data-edit-field'), value: el.innerText.trim() }, '*');
      });
      el.addEventListener('blur', () => {
        window.parent.postMessage({ type: 'content-update', isCapturePopup: true, field: el.getAttribute('data-edit-field'), value: el.innerText.trim() }, '*');
      });
      el.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); el.blur(); } });
    });
    document.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); }, true);
  </script>
</body></html>`;
    }


    // Normalize function for robust matching
    const normalizeName = (str) => (str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const normNodeId = normalizeName(node.id);
    const normNodeLabel = normalizeName(node.title || node.label || node.data?.label || '');
    const normType = normalizeName(type);

    // ── Priority 1: Exact match by page_${angleId} or page_${nodeId} ──
    // Pages built by the Page Builder Agent are saved with this prefix.
    const angleId = node.data?.angleId;
    let variant = null;
    if (angleId) {
      const pageName = normalizeName(`page_${angleId}`);
      variant = variants.find(v => normalizeName(v?.name) === pageName);
    }
    if (!variant) {
      const pageName = normalizeName(`page_${node.id}`);
      variant = variants.find(v => normalizeName(v?.name) === pageName);
    }

    // ── Priority 2: Exact match by node id, label, or type ──
    if (!variant) {
      variant = variants.find(v => {
        const vName = normalizeName(v?.name);
        return vName && (vName === normNodeId || vName === normNodeLabel || vName === normType);
      });
    }

    // ── Priority 3: Prefix-based fuzzy match ──
    if (!variant) {
      variant = variants.find(v => {
        const vName = normalizeName(v?.name);
        return vName && (normNodeId.startsWith(vName) || vName.startsWith(normNodeId) ||
               normNodeLabel.startsWith(vName) || vName.startsWith(normNodeLabel));
      });
    }

    if (!variant) {
      variant = variants.find(v => {
        const vName = normalizeName(v?.name);
        return vName && (vName.startsWith(normType) || normType.startsWith(vName));
      });
    }

    if (!variant) {
      variant = variants.find(v => {
        const vName = normalizeName(v?.name);
        if (!vName) return false;
        if (type === 'landing' || type === 'squeeze' || type === 'main') {
          return vName.startsWith('landing') || vName.startsWith('squeeze') || vName.startsWith('main') || vName.startsWith('hook');
        }
        if (type === 'video-hub' || type === 'training') {
          return vName.startsWith('video') || vName.startsWith('training');
        }
        if (type.startsWith('adv') || type === 'advertorial') {
          return vName.startsWith('adv') || vName.startsWith('editorial');
        }
        if (type === 'capture-popup' || type === 'capture') {
          return vName.startsWith('capture') || vName.startsWith('popup');
        }
        return vName.startsWith(type);
      });
    }
    
    let html = variant ? (variant.html_content || '') : '';
    // Only fall back to a blank template when html is truly empty.
    // Do NOT use `contenteditable` presence as a validity check — AI-built pages
    // are fully custom HTML and won't contain those attributes.
    if (!html) {
      html = getTemplateByType(type);
    }
    if (!html) return '';

    // Replace properties just like server dynamic compiler does
    const targetBase = type.toLowerCase();
    if (targetBase === 'landing' || targetBase === 'main' || targetBase === 'squeeze' || targetBase.startsWith('angle')) {
      const dynamicHeadline = pc.headline || node.title || campaignData?.name || 'Unlock Instant Access';
      const dynamicSubheadline = pc.subheadline || (campaignData?.niche ? `Discover the breakthrough strategy for ${campaignData.niche}. Get immediate access below.` : 'Discover the proven system and secure your access to the complete presentation below.');
      const dynamicCta = pc.ctaText || 'Get Instant Access →';

      html = html.replace(/Free Affiliate Marketing Course/gi, dynamicHeadline);
      html = html.replace(/Learn Affiliate Marketing with AI/gi, dynamicHeadline);
      html = html.replace(/Unlock the AI Wealth Protocol/gi, dynamicHeadline);
      html = html.replace(/Discover the exact systematic routing designed to automate your campaigns\. Grab our complete step-by-step video blueprint absolutely free\./gi, dynamicSubheadline);
      html = html.replace(/Discover the exact systematic routing designed to automate your campaigns\./gi, dynamicSubheadline);
      html = html.replace(/Where shall we send the Neural Strategy PDF and the full 12-minute breakdown\?/gi, dynamicSubheadline);
      html = html.replace(/Subscribe Free/gi, dynamicCta);
      html = html.replace(/Send My Strategy &rarr;/gi, dynamicCta);
      html = html.replace(/Send My Strategy →/gi, dynamicCta);

      if (pc.headline) {
        html = html.replace('Unlock Instant Access', pc.headline);
      } else {
        html = html.replace('Unlock Instant Access', dynamicHeadline);
      }
      if (pc.subheadline) {
        html = html.replace('Discover the proven system and secure your access to the complete presentation below.', pc.subheadline);
      } else {
        html = html.replace('Discover the proven system and secure your access to the complete presentation below.', dynamicSubheadline);
      }
      if (pc.ctaText) {
        html = html.replace('Get Instant Access →', pc.ctaText);
      }
      if (campaignData?.isPartnerHub) {
        const videoTag = `
            <video class="w-full h-full object-cover" controls playsinline>
                <source src="https://firebasestorage.googleapis.com/v0/b/affiliate-ninja-app-2026.firebasestorage.app/o/VSL%2FBecome-an-Affiliate-Ninja.mp4?alt=media&token=b5dcb15b-5ff4-41fe-9c35-a121350a03d4" type="video/mp4">
                Your browser does not support the video tag.
            </video>`;
        
        // Match the container open tag and replace classes
        html = html.replace(
          /<div id="ninja-video-container" class="([^"]*) flex items-center justify-center relative">/i,
          '<div id="ninja-video-container" class="$1 relative">'
        );
        
        // Regex to match anything between the opening tag of #ninja-video-container and the third closing </div>
        html = html.replace(
          /(<div id="ninja-video-container"[^>]*>)[\s\S]*?(<\/div>\s*<\/div>\s*<\/div>)/i,
          `$1${videoTag}</div>`
        );
      }
    } else if (targetBase.startsWith('quiz')) {
      if (pc.headline) {
        html = html.replace('Quick Quiz: Find Out If You Qualify', pc.headline);
      }
      if (pc.question) {
        html = html.replace('What is your primary fitness goal?', pc.question);
      }
      if (pc.option1) {
        html = html.replace('Lose weight and burn fat', pc.option1);
      }
      if (pc.option2) {
        html = html.replace('Boost energy levels', pc.option2);
      }
      if (pc.option3) {
        html = html.replace('Build long-term health', pc.option3);
      }
      if (pc.ctaText) {
        html = html.replace('Submit & See If I Qualify →', pc.ctaText);
      }
    } else if (targetBase.startsWith('bridge')) {
      if (pc.headline) {
        html = html.replace('Why We Recommend This Special Solution', pc.headline);
      }
      if (pc.subheadline) {
        html = html.replace('We analyzed over 50 different alternatives. This is the only one that met our criteria for performance, speed, and overall value.', pc.subheadline);
      }
      if (pc.ctaText) {
        html = html.replace('Continue to Official Offer →', pc.ctaText);
      }
    } else if (targetBase === 'video-hub' || targetBase === 'training') {
      if (pc.headline) {
        html = html.replace('Affiliate Marketing Mastery Course', pc.headline);
        html = html.replace('The AI Affiliate Blueprint', pc.headline);
      }
      if (pc.description) {
        html = html.replace('Watch the lessons below to deploy your AI affiliate engine and scale to $1k/day.', pc.description);
        html = html.replace('Watch the full training below. This is the exact system used to generate affiliate commissions on autopilot.', pc.description);
      }
      if (pc.ctaText) {
        html = html.replace('Deploy Your Affiliate Flow AI Engine', pc.ctaText);
        html = html.replace('Deploy Affiliate Engine &rarr;', pc.ctaText);
        html = html.replace('Deploy Affiliate Engine →', pc.ctaText);
      }
      const courseDataVal = pc.courseData || defaultCourseData;
      html = html.replace('{course_data_json}', JSON.stringify(courseDataVal));
    } else if (targetBase.startsWith('adv')) {
      if (pc.headline) {
        html = html.replace('Write a compelling advertorial headline...', pc.headline);
      }
      if (pc.subheadline) {
        html = html.replace('Subheadline explaining the editorial hook...', pc.subheadline);
      }
      if (pc.body) {
        html = html.replace('This is where you write the pre-sell story. Warm up the visitors with a great hook, build social proof, and lead them to the affiliate link...', pc.body);
      }
      if (pc.ctaText) {
        html = html.replace('Claim Your Deal Now →', pc.ctaText);
        html = html.replace('Claim Your Deal Now &rarr;', pc.ctaText);
      }
    } else if (targetBase === 'listicle') {
      if (pc.headline) {
        html = html.replace('Top Reviewed Products', pc.headline);
      }
      if (pc.subheadline) {
        html = html.replace('Compare the best options available.', pc.subheadline);
      }
    } else if (targetBase === 'capture-popup' || targetBase === 'capture') {
      if (pc.headline) {
        html = html.replace('Unlock Instant Access', pc.headline);
      }
      if (pc.subheadline || pc.subtext) {
        const targetSub = pc.subheadline || pc.subtext;
        html = html.replace('Enter your best email address below to secure your spot and redirect to the presentation.', targetSub);
      }
      if (pc.ctaText || pc.btnText) {
        const targetBtn = pc.ctaText || pc.btnText;
        html = html.replace('Get Instant Access', targetBtn);
      }
      if (pc.inputPlaceholder) {
        html = html.replace('placeholder="name@email.com"', `placeholder="${pc.inputPlaceholder}"`);
      }
    }

    // Replace images dynamically in the HTML content if configured
    if (pc.image) {
      html = html.replace(/src="https:\/\/(image\.pollinations\.ai|images\.unsplash\.com)[^"]*"/gi, `src="${pc.image}"`);
    }

    // Inject Tailwind custom config to support slate-850, slate-855, and slate-955 in Play CDN
    html = html.replace('<script src="https://cdn.tailwindcss.com"></script>', 
      `<script src="https://cdn.tailwindcss.com"></script>
      <script>
        tailwind.config = {
          theme: {
            extend: {
              colors: {
                slate: {
                  850: '#131722',
                  855: '#11151e',
                  955: '#07090e'
                }
              }
            }
          }
        }
      </script>`
    );

    const username = campaignData?.username || 'user';
    const slug = campaignData?.slug || 'slug';
    const queryString = '';
    html = html.replace(/\{tracking_url\}/g, `/u/${username}/${slug}${queryString}`);
    if (campaignData?.affiliateLink) {
      html = html.replace(/\{affiliate_link\}/g, campaignData.affiliateLink);
    }
    
    // If there is a capture popup node in the funnel, inject the capture popup modal HTML
    const captureNode = nodes.find(n => n.type === 'capture-popup');
    if (captureNode && (type === 'landing' || type === 'video-hub' || type === 'listicle' || type.startsWith('adv'))) {
      const cpc = captureNode.pageContent || {};
      const popupHeadline = cpc.headline || 'Unlock Instant Access';
      const popupSubtext = cpc.subheadline || cpc.subtext || 'Enter your best email address below to secure your spot and redirect to the presentation.';
      const popupBtnText = cpc.ctaText || cpc.btnText || 'Get Instant Access';
      const popupPlaceholder = cpc.inputPlaceholder || 'name@email.com';
      
      const captureModalHtml = `
<!-- Capture Popup Modal -->
<div id="ninja-capture-modal" class="fixed inset-0 z-50 hidden items-center justify-center p-4 bg-slate-950/80 backdrop-blur-md transition-all duration-300">
    <div class="absolute inset-0 cursor-default" onclick="closeNinjaModal()"></div>
    <div class="relative w-full max-w-lg bg-slate-900 border border-slate-800/80 text-white p-8 md:p-10 rounded-[2rem] shadow-2xl shadow-indigo-500/10 transform scale-95 transition-all duration-300 flex flex-col items-center text-center">
        <button onclick="closeNinjaModal()" class="absolute top-5 right-5 text-slate-400 hover:text-white transition-colors p-2 rounded-full hover:bg-slate-800">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
        </button>
        <div class="w-20 h-20 bg-gradient-to-tr from-indigo-500 to-purple-600 rounded-3xl flex items-center justify-center shadow-lg shadow-indigo-500/25 mb-6">
            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
        </div>
        <h3 data-edit-field="headline" data-node-type="capture-popup" contenteditable="true" class="outline-none focus:ring-2 focus:ring-purple-500 rounded-2xl px-3 py-1.5 text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-white via-slate-100 to-slate-300 tracking-tight leading-tight mb-4">
            ${popupHeadline}
        </h3>
        <p data-edit-field="subheadline" data-node-type="capture-popup" contenteditable="true" class="outline-none focus:ring-2 focus:ring-purple-500 rounded-2xl px-3 py-1.5 text-slate-400 text-base md:text-lg mb-8 leading-relaxed max-w-sm">
            ${popupSubtext}
        </p>
        <div class="w-full space-y-4">
            <div class="relative">
                <span class="absolute inset-y-0 left-0 flex items-center pl-4 text-slate-500">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.206"></path></svg>
                </span>
                <input type="email" id="ninja-optin-email" placeholder="${popupPlaceholder}" class="w-full pl-12 pr-4 py-4 bg-slate-950/50 border border-slate-800 rounded-2xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-white placeholder-slate-500 transition-all text-lg shadow-inner" disabled>
            </div>
            <button class="w-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white font-extrabold text-xl py-4 rounded-2xl shadow-lg shadow-indigo-500/25 flex items-center justify-center gap-3">
                <span data-edit-field="ctaText" data-node-type="capture-popup" contenteditable="true" class="outline-none focus:ring-2 focus:ring-purple-500 rounded px-2">${popupBtnText}</span>
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
            </button>
        </div>
        <p class="text-sm text-slate-500 mt-6 flex items-center justify-center gap-2">
            <svg class="w-5 h-5 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path></svg>
            We respect your privacy. Spam-free experience.
        </p>
    </div>
</div>

<script>
function openNinjaCapturePopup() {
    const modal = document.getElementById('ninja-capture-modal');
    if (modal) {
        modal.classList.remove('hidden');
        modal.classList.add('flex');
    }
}
function closeNinjaModal() {
    const modal = document.getElementById('ninja-capture-modal');
    if (modal) {
        modal.classList.remove('flex');
        modal.classList.add('hidden');
    }
}
</script>
      `;

      const bodyClose = html.toLowerCase().lastIndexOf('</body>');
      if (bodyClose !== -1) {
        html = html.substring(0, bodyClose) + captureModalHtml + html.substring(bodyClose);
      } else {
        html = html + captureModalHtml;
      }

      // Add script to force open/close the modal depending on showPopupOverlay toggle state
      const toggleScript = `
        <script>
          window.addEventListener('DOMContentLoaded', () => {
            if (${showPopupOverlay}) {
              if (typeof openNinjaCapturePopup === 'function') openNinjaCapturePopup();
            } else {
              if (typeof closeNinjaModal === 'function') closeNinjaModal();
            }
          });
          setTimeout(() => {
            if (${showPopupOverlay}) {
              if (typeof openNinjaCapturePopup === 'function') openNinjaCapturePopup();
            }
          }, 100);
        </script>
      `;
      const finalBodyClose = html.toLowerCase().lastIndexOf('</body>');
      if (finalBodyClose !== -1) {
        html = html.substring(0, finalBodyClose) + toggleScript + html.substring(finalBodyClose);
      } else {
        html = html + toggleScript;
      }
    }

    // Inject editorStyles, floating toolbars, and event listener scripts
    const editorScript = `
      <style>
        /* Inline Editor Styles */
        [contenteditable="true"] {
          position: relative;
          cursor: text;
          transition: box-shadow 0.2s ease;
        }
        [contenteditable="true"]:hover {
          box-shadow: 0 0 0 1px rgba(249, 115, 22, 0.4);
        }
        [contenteditable="true"]:focus {
          outline: none;
          box-shadow: 0 0 0 2px #f97316 !important; /* orange-500 */
        }
        [data-node-type="capture-popup"]:hover {
          box-shadow: 0 0 0 1px rgba(167, 139, 250, 0.4) !important;
        }
        [data-node-type="capture-popup"]:focus {
          box-shadow: 0 0 0 2px #a78bfa !important; /* purple-400 */
        }
        
        /* Floating Toolbars */
        .ninja-floating-toolbar {
          position: absolute;
          z-index: 100000;
          display: none;
          align-items: center;
          gap: 6px;
          background: rgba(15, 23, 42, 0.95);
          backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          padding: 4px 8px;
          border-radius: 12px;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5), 0 0 10px rgba(99, 102, 241, 0.2);
          pointer-events: auto;
          font-family: system-ui, -apple-system, sans-serif;
        }
        .ninja-toolbar-btn {
          background: linear-gradient(135deg, #6366f1, #a855f7);
          color: white;
          font-size: 10px;
          font-weight: 800;
          padding: 4px 8px;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 4px;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          transition: all 0.2s;
        }
        .ninja-toolbar-btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
        }
        .ninja-image-overlay {
          position: absolute;
          z-index: 9999;
          display: none;
          background: rgba(15, 23, 42, 0.6);
          backdrop-filter: blur(4px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          pointer-events: none;
          transition: all 0.2s;
        }
        .ninja-image-btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: rgba(15, 23, 42, 0.9);
          border: 1px solid rgba(255, 255, 255, 0.15);
          color: white;
          font-size: 10px;
          font-weight: 800;
          padding: 6px 12px;
          border-radius: 8px;
          cursor: pointer;
          pointer-events: auto;
          display: flex;
          align-items: center;
          gap: 6px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.5);
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }
        .ninja-image-btn:hover {
          background: #f97316;
          border-color: #f97316;
        }
      </style>

      <!-- Create the toolbar dynamically -->
      <div id="ninja-text-toolbar" class="ninja-floating-toolbar">
        <button class="ninja-toolbar-btn" onclick="handleAiRewriteClick(event)">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="width:10px;height:10px;"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
          <span>AI Rewrite</span>
        </button>
      </div>
      
      <div id="ninja-image-overlay" class="ninja-image-overlay">
        <button class="ninja-image-btn" onclick="handleImageChangeClick(event)">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="width:12px;height:12px;"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
          <span>AI Change Image</span>
        </button>
      </div>

      <script>
        let activeTextElement = null;
        let activeImageElement = null;

        // Block navigation click interceptor
        document.addEventListener('click', function(e) {
          // Allow clicks on editable items or editor toolbars
          if (e.target.closest('[contenteditable="true"]') ||
              e.target.closest('#ninja-text-toolbar') ||
              e.target.closest('#ninja-image-overlay')) {
            return;
          }
          
          const modal = document.getElementById('ninja-capture-modal');
          if (modal && modal.contains(e.target)) {
            return;
          }
          // Block navigation/form clicks in preview — do NOT open popup here
          e.preventDefault();
          e.stopPropagation();
        }, true);

        document.addEventListener('submit', function(e) {
          e.preventDefault();
          e.stopPropagation();
        }, true);

        // Listen to focus/input on editable elements
        document.querySelectorAll('[contenteditable="true"]').forEach(el => {
          el.addEventListener('keydown', e => {
            if (e.key === 'Enter' && el.getAttribute('data-edit-field') !== 'body') {
              e.preventDefault();
              el.blur();
            }
          });

          // No input event — only save on blur to avoid iframe reload while typing

          el.addEventListener('blur', e => {
            const field = el.getAttribute('data-edit-field');
            const isCapture = el.getAttribute('data-node-type') === 'capture-popup';
            const value = el.innerText.trim();
            window.parent.postMessage({
              type: 'content-update',
              isCapturePopup: isCapture,
              field: field,
              value: value
            }, '*');
            setTimeout(() => {
              if (activeTextElement === el) {
                document.getElementById('ninja-text-toolbar').style.display = 'none';
              }
            }, 200);
          });

          el.addEventListener('focus', e => {
            activeTextElement = el;
            const toolbar = document.getElementById('ninja-text-toolbar');
            
            const rect = el.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            
            toolbar.style.display = 'flex';
            const toolbarRect = toolbar.getBoundingClientRect();
            toolbar.style.top = (rect.top + scrollTop - toolbarRect.height - 8) + 'px';
            toolbar.style.left = Math.max(10, (rect.left + scrollLeft + (rect.width - toolbarRect.width)/2)) + 'px';
          });
        });

        // Handle AI Rewrite click
        function handleAiRewriteClick(e) {
          e.preventDefault();
          e.stopPropagation();
          if (activeTextElement) {
            const field = activeTextElement.getAttribute('data-edit-field');
            const text = activeTextElement.innerText.trim();
            window.parent.postMessage({
              type: 'ai-prompt-text',
              field: field,
              text: text
            }, '*');
          }
        }

        // Hover listeners for images
        document.querySelectorAll('img').forEach(img => {
          if (img.classList.contains('w-6') || img.classList.contains('w-10') || img.classList.contains('animate-spin') || img.id === 'close-modal-img') return;
          
          img.addEventListener('mouseenter', e => {
            activeImageElement = img;
            const overlay = document.getElementById('ninja-image-overlay');
            const rect = img.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

            overlay.style.display = 'block';
            overlay.style.width = rect.width + 'px';
            overlay.style.height = rect.height + 'px';
            overlay.style.top = (rect.top + scrollTop) + 'px';
            overlay.style.left = (rect.left + scrollLeft) + 'px';
          });
        });

        const overlay = document.getElementById('ninja-image-overlay');
        overlay.addEventListener('mouseleave', e => {
          overlay.style.display = 'none';
        });

        function handleImageChangeClick(e) {
          e.preventDefault();
          e.stopPropagation();
          window.parent.postMessage({
            type: 'ai-prompt-image',
            field: 'image'
          }, '*');
          overlay.style.display = 'none';
        }
      </script>
    `;
    // Dynamic legal compliance footer injection in client-side compiler — only append if not already present
    if (!html.includes('<!-- Legal Compliance Footer -->')) {
      const usernameVal = campaignData?.username || 'partner';
      const footerHtml = `
<!-- Legal Compliance Footer -->
<footer class="mt-20 py-8 border-t border-slate-900/40 text-center text-xs text-slate-500 space-y-2">
    <p>© 2026 Affiliate Flow AI Network. All rights reserved.</p>
    <div class="flex justify-center space-x-6">
        <a href="/${usernameVal}/terms" target="_blank" class="hover:text-slate-400 transition">Terms of Service</a>
        <a href="/${usernameVal}/privacy" target="_blank" class="hover:text-slate-400 transition">Privacy Policy</a>
        <a href="https://affiliateflow.ai" target="_blank" class="hover:text-slate-400 transition">Powered by Affiliate Flow AI</a>
    </div>
    <p class="text-[10px] text-slate-700 max-w-xl mx-auto mt-4 leading-relaxed px-4">
        Disclaimer: We are an independent review and training portal. Earnings and results mentioned in training are illustrative only. Standard affiliate commission tracking is active on this domain.
    </p>
</footer>
`;
      const footerCloseIdx = html.toLowerCase().lastIndexOf('</body>');
      if (footerCloseIdx !== -1) {
        html = html.substring(0, footerCloseIdx) + footerHtml + html.substring(footerCloseIdx);
      } else {
        html = html + footerHtml;
      }
    }

    const bodyClose = html.toLowerCase().lastIndexOf('</body>');
    if (bodyClose !== -1) {
      html = html.substring(0, bodyClose) + editorScript + html.substring(bodyClose);
    } else {
      html = html + editorScript;
    }
    
    return html;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignData, localPages, node.id, node.type, showPopupOverlay]);
  // NOTE: pc and nodes intentionally excluded — editing text updates pc which would
  // reload the iframe on every keystroke. Values are baked in at mount/node-switch time.

  const handleSendMessage = (text, userOriginated = true) => {
    if (!text.trim()) return;

    if (userOriginated) {
      setChatMessages(prev => [...prev, { role: 'user', content: text }]);
    }
    setChatInput('');
    setIsTyping(true);

    setTimeout(() => {
      let reply = "";
      const query = text.toLowerCase();

      if (query.includes('headline') || query.includes('rewrite') || query.includes('hook')) {
        reply = `I have drafted an optimized headline based on direct-response copywriting principles:
"Unlock the AI Wealth Protocol: Grab the Complete 2026 Strategy Package Free"

I've automatically updated it on your page. Look at the preview to see it live!`;
        updateField('headline', "Unlock the AI Wealth Protocol: Grab the Complete 2026 Strategy Package Free");
        triggerGlow('headline');
      } else if (query.includes('image') || query.includes('graphic') || query.includes('regenerate')) {
        const nextImg = DEFAULT_IMAGES[Math.floor(Math.random() * DEFAULT_IMAGES.length)];
        updateField('image', nextImg);
        reply = `I've generated a new optimized hero visual for your landing page. Check the updated preview!`;
        triggerGlow('image');
      } else if (query.includes('subheadline') || query.includes('sub')) {
        reply = `I've rewritten the subheadline to build on your headline:
"Where shall we send the Neural Strategy PDF and the full 12-minute breakdown?"`;
        updateField('subheadline', "Where shall we send the Neural Strategy PDF and the full 12-minute breakdown?");
        triggerGlow('subheadline');
      } else if (query.includes('cta') || query.includes('button') || query.includes('text')) {
        reply = `I have optimized the Call-to-Action button text to create high urgency:
"Send My Strategy â†’"`;
        updateField('ctaText', "Send My Strategy â†’");
        triggerGlow('ctaText');
      } else {
        reply = `I've analyzed your page segment. Let's make sure the copy matches your niche. 

Would you like me to:
1. âš¡ Rewrite the headline for higher click-through-rates.
2. ðŸŽ¨ Generate a new hero graphic/illustration.
3. âœï¸ Draft a benefits checklist to increase conversion.`;
      }

      setChatMessages(prev => [...prev, { role: 'ai', content: reply }]);
      setIsTyping(false);
    }, 1200);
  };

  // 1. Listen for user auth changes and load their profile
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user && user.email) {
        try {
          const emailClean = user.email.toLowerCase().trim();
          const docRef = doc(db, 'profiles', emailClean);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setProfile(docSnap.data());
          }
        } catch (err) {
          console.error("Error loading profile in VisualPageEditor:", err);
        }
      }
    });
    return () => unsubscribe();
  }, []);

  // 2. Fetch MailerXP lists and segments
  const fetchListsAndSegments = async (apiKeyOverride) => {
    const key = apiKeyOverride || profile?.mailerXpApi;
    if (!key) return;
    setLoadingMailerXp(true);
    setMailerXpError(null);
    try {
      const [listsRes, segmentsRes] = await Promise.all([
        fetch('/api/mailerxp/lists', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ apiKey: key })
        }),
        fetch('/api/mailerxp/segments', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ apiKey: key })
        })
      ]);

      if (!listsRes.ok) {
        const errData = await listsRes.json();
        throw new Error(errData.error || 'Failed to fetch lists');
      }
      if (!segmentsRes.ok) {
        const errData = await segmentsRes.json();
        throw new Error(errData.error || 'Failed to fetch segments');
      }

      const listsData = await listsRes.json();
      const segmentsData = await segmentsRes.json();
      
      const parsedLists = Array.isArray(listsData) ? listsData : (listsData.lists || listsData.data || []);
      const parsedSegments = Array.isArray(segmentsData) ? segmentsData : (segmentsData.segments || segmentsData.data || []);

      setMailerXpLists(parsedLists);
      setMailerXpSegments(parsedSegments);
    } catch (err) {
      console.error("MailerXP loading error:", err);
      setMailerXpError(err.message);
    } finally {
      setLoadingMailerXp(false);
    }
  };

  useEffect(() => {
    if (profile?.mailerXpApi) {
      fetchListsAndSegments();
    }
  }, [profile?.mailerXpApi]);

  const handleSaveInlineApiKey = async (key) => {
    if (!key || !key.trim()) return;
    const cleanKey = key.trim();
    setSavingApiKey(true);
    try {
      const user = auth.currentUser;
      if (user && user.email) {
        const emailClean = user.email.toLowerCase().trim();
        const docRef = doc(db, 'profiles', emailClean);
        await setDoc(docRef, { mailerXpApi: cleanKey }, { merge: true });
      }
      setProfile(prev => ({ ...prev, mailerXpApi: cleanKey }));
      await fetchListsAndSegments(cleanKey);
    } catch (err) {
      console.error("Failed to save MailerXP API key:", err);
      alert("Failed to save MailerXP API key: " + err.message);
    } finally {
      setSavingApiKey(false);
    }
  };

  const handleCreateList = async () => {
    if (!newListName.trim()) return;
    const key = profile?.mailerXpApi;
    if (!key) return;
    setCreatingList(true);
    setCreateListError(null);
    try {
      const res = await fetch('/api/mailerxp/lists/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ apiKey: key, name: newListName.trim() })
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        throw new Error(data.error || 'Failed to create list');
      }
      const created = data.list;
      setMailerXpLists(prev => [created, ...prev]);
      updateField('mailerXpList', created.id);
      if (node.type === 'capture-popup') {
        updateCaptureField('mailerXpList', created.id);
      }
      setNewListName('');
      setShowCreateList(false);
    } catch (err) {
      setCreateListError(err.message);
    } finally {
      setCreatingList(false);
    }
  };

  // 3. Set initial active tab based on node type (Connection Settings for Capture Popup, AI Coach for others)
  useEffect(() => {
    if (node.type === 'capture-popup') {
      setActiveTab('connection');
    } else {
      setActiveTab('coach');
    }
  }, [node.type]);

  // 4. Message Bridge listener from inside simulator iframe
  useEffect(() => {
    const handleMessage = (e) => {
      const data = e.data;
      if (!data || typeof data !== 'object') return;

      if (data.type === 'content-update') {
        const { field, value, isCapturePopup } = data;
        if (isCapturePopup || node.type === 'capture-popup') {
          updateCaptureField(field, value);
        } else {
          updateField(field, value);
        }
      } else if (data.type === 'ai-prompt-text') {
        const { field, text } = data;
        setActiveTab('coach');
        let promptMsg = '';
        if (field === 'headline') {
          promptMsg = 'Rewrite the headline for high click-through rates. Make it extremely compelling.';
        } else if (field === 'subheadline') {
          promptMsg = 'Rewrite the subheadline to build curiosity and interest.';
        } else if (field === 'ctaText') {
          promptMsg = 'Optimize the CTA button text for higher conversion rate.';
        } else {
          promptMsg = `Rewrite the ${field} starting from: "${text}"`;
        }
        handleSendMessage(promptMsg);
      } else if (data.type === 'ai-prompt-image') {
        setActiveTab('coach');
        handleSendMessage('Regenerate the hero graphic on the page.');
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [node, pc, captureNode]);

  const triggerGlow = (field) => {
    setGlowField(field);
    setTimeout(() => {
      setGlowField(null);
    }, 2500);
  };

  const currentCategory = useMemo(() => {
    if (node.type === 'traffic') return { label: 'Traffic Source', color: C.green };
    if (node.type === 'adv-a' || node.type === 'adv-b') return { label: 'Advertorial Page', color: C.purple };
    if (node.type === 'landing') return { label: 'Landing Page', color: C.blue };
    if (node.type === 'listicle') return { label: 'Product Listicle', color: C.orange };
    if (node.type === 'video-hub') return { label: 'Video Academy Hub', color: C.violet };
    if (node.type === 'capture-popup') return { label: 'Capture Popup Overlay', color: C.purple };
    if (node.type === 'offer') return { label: 'Affiliate Offer Route', color: C.yellow };
    return { label: 'Page Node', color: C.orange };
  }, [node]);

  return (
    <div className={isInline ? "relative w-full h-full bg-slate-950 flex flex-col overflow-hidden font-sans" : "fixed inset-0 z-[150] bg-slate-950/98 backdrop-blur-md flex flex-col overflow-hidden animate-in fade-in duration-300 font-sans"}>
      
      {/* Header Bar */}
      <header className="h-16 border-b border-slate-800 px-6 flex items-center justify-between bg-slate-900/50 shrink-0 select-none">
        <div className="flex items-center space-x-3">
          <div 
            className="px-2.5 py-1 text-[9px] font-black uppercase tracking-widest rounded border"
            style={{ 
              color: currentCategory.color, 
              borderColor: `${currentCategory.color}40`,
              background: `${currentCategory.color}08`
            }}
          >
            {currentCategory.label}
          </div>
          <div className="text-left">
            <h2 className="text-sm font-extrabold text-white">
              {node.title || 'Edit Page Content'}
            </h2>
            <span className="text-[9px] font-bold text-slate-500 uppercase tracking-widest block mt-0.5">
              Active Funnel Pipeline Workspace
            </span>
          </div>
        </div>

        {/* Center Device Toggler */}
        {node.type !== 'traffic' && (
          <div className="flex bg-slate-950/60 p-1 rounded-xl border border-slate-850">
            <button 
              onClick={() => setPreviewDevice('desktop')}
              className={`flex items-center space-x-1 px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-wider transition-all ${
                previewDevice === 'desktop' ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-600/10' : 'text-slate-500 hover:text-slate-300'
              }`}
            >
              <Monitor size={14} />
              <span className="hidden md:inline ml-1">Desktop</span>
            </button>
            <button 
              onClick={() => setPreviewDevice('mobile')}
              className={`flex items-center space-x-1 px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-wider transition-all ${
                previewDevice === 'mobile' ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-600/10' : 'text-slate-500 hover:text-slate-300'
              }`}
            >
              <Smartphone size={14} />
              <span className="hidden md:inline ml-1">Mobile</span>
            </button>
          </div>
        )}

        {captureNode && (node.type === 'landing' || node.type === 'video-hub' || node.type === 'listicle' || node.type.startsWith('adv')) && (
          <button 
            onClick={() => setShowPopupOverlay(prev => !prev)}
            className={`flex items-center space-x-1.5 px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all border ${
              showPopupOverlay 
                ? 'bg-purple-600 text-white border-purple-500 shadow-lg shadow-purple-600/15' 
                : 'bg-slate-950/60 text-slate-400 border-slate-850 hover:text-slate-300'
            }`}
          >
            <span>💬 {showPopupOverlay ? 'Hide Popup' : 'Preview Popup'}</span>
          </button>
        )}

        {/* Autoresponder Integration Toggle Button */}
        {(() => {
          const activeCustomForm = pc.customForm || captureNode?.pageContent?.customForm || campaignData?.customForm;
          const isCustomConnected = !!(activeCustomForm?.action);
          const isConnected = isMailerXpConnected || isCustomConnected;
          const label = isCustomConnected 
            ? `${activeCustomForm.provider || 'Custom Form'} Connected` 
            : isMailerXpConnected 
              ? (connectedListName ? `MailerXP: ${connectedListName}` : 'MailerXP Connected') 
              : hasOptinForm
                ? '⚠️ Connect MailerXP'
                : 'Autoresponder';

          return (
            <button 
              type="button"
              onClick={() => setShowAutoresponder(prev => !prev)}
              className={`flex items-center space-x-1.5 px-3.5 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all border ${
                showAutoresponder 
                  ? 'bg-purple-600 text-white border-purple-500 shadow-lg shadow-purple-600/20' 
                  : isConnected
                    ? 'bg-emerald-500/10 text-emerald-300 border-emerald-500/30 hover:bg-emerald-500/20'
                    : hasOptinForm
                      ? 'bg-purple-500/15 text-purple-300 border-purple-500/40 hover:bg-purple-500/25 animate-pulse'
                      : 'bg-slate-950/60 text-slate-400 border-slate-850 hover:text-slate-200'
              }`}
              title="Autoresponder & Lead Capture Integration (MailerXP, AWeber, GetResponse, etc.)"
            >
              <span>{isCustomConnected ? '📝' : '📬'}</span>
              <span>{label}</span>
              {isConnected && (
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400"></span>
              )}
            </button>
          );
        })()}

        {/* Right Close & Save Actions */}
        <div className="flex items-center space-x-3">
          {!isPageBuilt && onBuildPage && node.type !== 'traffic' && (
            <button
              type="button"
              onClick={() => onBuildPage(node)}
              className="flex items-center space-x-1.5 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white text-[10px] font-black rounded-xl uppercase tracking-widest transition-all shadow-lg shadow-orange-500/20 active:scale-95 cursor-pointer"
            >
              <span>🛠</span>
              <span>Build with AI</span>
            </button>
          )}
          <button 
            onClick={onClose}
            className="flex items-center space-x-2 px-6 py-2.5 bg-orange-600 hover:bg-orange-500 text-white text-[10px] font-black rounded-xl uppercase tracking-widest transition-all shadow-lg shadow-orange-500/20 active:scale-95"
          >
            <Check size={14} />
            <span>Save & Exit</span>
          </button>
          <button 
            onClick={onClose}
            className="p-2.5 text-slate-500 hover:text-white hover:bg-slate-800 rounded-xl transition-all"
          >
            <X size={20} />
          </button>
        </div>
      </header>

      {/* Main Column Split */}
      <div className="flex-1 flex overflow-hidden">
        
        {/* Left Column: Interactive Simulator Workspace */}
        <div className="flex-1 bg-slate-950 p-6 sm:p-10 flex flex-col items-center justify-center overflow-y-auto custom-scrollbar select-none relative">
          
          {glowField && (
            <div className="absolute inset-0 border-2 border-indigo-500/60 shadow-[inset_0_0_50px_rgba(99,102,241,0.15)] pointer-events-none z-50 animate-pulse rounded-2xl" />
          )}

          {/* Unbuilt Page Alert Notice */}
          {!isPageBuilt && node.type !== 'traffic' && (
            <div className="w-full max-w-5xl mb-4 bg-amber-500/10 border border-amber-500/25 rounded-2xl p-4 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-xl shrink-0">
              <div className="flex items-center gap-3 text-amber-300 text-xs">
                <span className="text-xl">⚠️</span>
                <div>
                  <div className="font-bold text-amber-200">Page Not Built Yet (Placeholder Mode)</div>
                  <div className="text-amber-400/80 text-[11px] mt-0.5">
                    This page has not been generated by the Page Builder Agent. Run the AI Page Builder to craft custom copy and design for <strong>{node.title || campaignData?.name || 'this angle'}</strong>.
                  </div>
                </div>
              </div>
              {onBuildPage && (
                <button
                  type="button"
                  onClick={() => onBuildPage(node)}
                  className="shrink-0 px-4 py-2 bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white text-[11px] font-black uppercase tracking-wider rounded-xl shadow-lg flex items-center gap-2 cursor-pointer transition-all active:scale-95"
                >
                  🛠 Build Page with AI
                </button>
              )}
            </div>
          )}

          {/* Opt-in Form Status Notice */}
          {isPageBuilt && hasOptinForm && node.type !== 'traffic' && (
            <div className={`w-full max-w-5xl mb-4 rounded-2xl p-4 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-xl shrink-0 border ${
              isMailerXpConnected 
                ? 'bg-emerald-500/10 border-emerald-500/25 text-emerald-300' 
                : 'bg-purple-500/10 border-purple-500/30 text-purple-200'
            }`}>
              <div className="flex items-center gap-3 text-xs">
                <span className="text-xl">{isMailerXpConnected ? '📬' : '⚠️'}</span>
                <div>
                  <div className="font-bold">
                    {isMailerXpConnected 
                      ? <>Opt-in Form Connected: <span className="text-white">{connectedListName}</span></>
                      : 'Opt-in Form Detected — MailerXP Not Connected Yet'}
                  </div>
                  <div className="text-[11px] opacity-80 mt-0.5">
                    {isMailerXpConnected 
                      ? <>Leads entered on this page will automatically sync to <strong>{connectedListName}</strong> in MailerXP.</>
                      : 'This page has an email opt-in form. Select your MailerXP subscriber list so incoming leads sync automatically.'}
                  </div>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setShowAutoresponder(true)}
                className={`shrink-0 px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-wider shadow-lg flex items-center gap-1.5 cursor-pointer transition-all active:scale-95 ${
                  isMailerXpConnected
                    ? 'bg-emerald-600/30 hover:bg-emerald-600/50 text-emerald-200 border border-emerald-500/40'
                    : 'bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white border border-purple-400/40'
                }`}
              >
                <span>{isMailerXpConnected ? '⚙️ Change List' : '📬 Connect MailerXP List'}</span>
              </button>
            </div>
          )}

          {/* Device Mockups */}
          {node.type === 'traffic' ? (
            <TrafficConfigurator 
              node={node} 
              campaignData={campaignData} 
              onUpdateNode={onUpdateNode} 
            />
          ) : previewDevice === 'desktop' ? (
            <div className="w-full max-w-5xl bg-[#0a0c12] rounded-2xl overflow-hidden border border-slate-800 flex flex-col shadow-2xl h-[75vh] transition-all duration-300">
              {/* Browser bar */}
              <div className="h-10 bg-slate-900/80 px-4 flex items-center space-x-4 border-b border-slate-800 shrink-0">
                <div className="flex space-x-1.5 shrink-0">
                  {['bg-rose-500', 'bg-yellow-500', 'bg-emerald-500'].map(c => (
                    <div key={c} className={`size-2.5 rounded-full ${c} opacity-75`} />
                  ))}
                </div>
                <div className="flex-1 bg-slate-950 border border-slate-850 rounded-md py-1 px-4 flex items-center text-[10px] text-slate-500 min-w-0">
                  <Globe size={11} className="mr-1.5 text-slate-600 shrink-0" />
                  <span className="truncate">https://xpgo.link/u/{campaignData?.username || 'user'}/{campaignData?.slug || 'page'}</span>
                </div>
              </div>
              <div className="flex-1 overflow-y-auto custom-scrollbar bg-slate-950 relative">
                {/* actual compiled HTML iframe rendering */}
                {compiledHtml ? (
                  <iframe 
                    srcDoc={compiledHtml}
                    className="w-full h-full border-none pointer-events-auto"
                    title="Funnel Live Preview"
                  />
                ) : (
                  <InteractiveMockup 
                    node={node} 
                    pageContent={pc} 
                    onUpdate={updateField} 
                    onAskAI={handleSendMessage} 
                  />
                )}
              </div>
            </div>
          ) : (
            <div className="w-[320px] bg-[#000] rounded-[3rem] p-3.5 border-4 border-slate-850 flex flex-col shadow-2xl h-[75vh] relative transition-all duration-300 shrink-0">
              <div className="absolute top-6 left-1/2 -translate-x-1/2 w-24 h-5 bg-black rounded-b-2xl z-40 flex items-center justify-center">
                <div className="w-8 h-1 bg-slate-900 rounded-full" />
              </div>
              
              <div className="flex-1 bg-slate-950 rounded-[2.2rem] overflow-hidden flex flex-col border border-slate-900">
                <div className="h-8 bg-slate-950 px-6 pt-2 pb-1 border-b border-slate-900 text-center flex items-center justify-center shrink-0">
                  <div className="w-full bg-slate-900 rounded-md py-0.5 text-[8px] text-slate-500 truncate flex items-center justify-center">
                    <Globe size={9} className="mr-1 text-slate-600" />
                    <span>xpgo.link/u/...</span>
                  </div>
                </div>
                <div className="flex-1 overflow-y-auto custom-scrollbar select-none bg-slate-955 relative">
                  {compiledHtml ? (
                    <iframe 
                      srcDoc={compiledHtml}
                      className="w-full h-full border-none pointer-events-auto"
                      title="Funnel Live Preview"
                    />
                  ) : (
                    <InteractiveMockup 
                      node={node} 
                      pageContent={pc} 
                      onUpdate={updateField} 
                      onAskAI={handleSendMessage} 
                    />
                  )}
                </div>
              </div>
            </div>
          )}

          {node.type !== 'traffic' && (
            <div className="absolute bottom-4 left-6 text-[10px] font-bold text-slate-500 uppercase tracking-wider flex items-center space-x-2 select-none">
              <span className="size-2 bg-orange-500 rounded-full animate-ping" />
              <span>Click any text on the page to edit it directly</span>
            </div>
          )}

        </div>

        {/* Right Column: Sidebar for MailerXP Autoresponder connection or Video Hub curriculum */}
        {(node.type === 'capture-popup' || (node.type === 'video-hub' && !showAutoresponder) || showAutoresponder) && (
        <aside className="w-80 sm:w-96 border-l border-slate-800 bg-slate-900/80 backdrop-blur-md flex flex-col shrink-0 overflow-hidden text-left">
          {/* Header */}
          <div className="px-6 py-4 border-b border-slate-800 shrink-0 flex items-center justify-between">
            <div>
              <div className="flex items-center space-x-2">
                <span className="text-sm">{(node.type === 'video-hub' && !showAutoresponder) ? '🎬' : '📬'}</span>
                <span className="text-[10px] font-black text-slate-300 uppercase tracking-widest">
                  {(node.type === 'video-hub' && !showAutoresponder) ? 'Curriculum Builder' : 'Autoresponder & Leads'}
                </span>
              </div>
              <p className="text-[9px] text-slate-500 mt-1">
                {(node.type === 'video-hub' && !showAutoresponder) ? 'Organize course sections, lessons, descriptions, and video URLs.' : 'Sync captured leads to MailerXP or custom form (AWeber, GetResponse, etc.).'}
              </p>
            </div>
            {node.type !== 'capture-popup' && (
              <button 
                type="button"
                onClick={() => setShowAutoresponder(false)}
                className="p-1.5 text-slate-500 hover:text-white rounded-lg hover:bg-slate-800 transition-all"
                title="Close Sidebar"
              >
                <X size={16} />
              </button>
            )}
          </div>

          {/* Connection Settings or Lesson Editor */}
          <div className="flex-1 overflow-y-auto p-6 space-y-6 custom-scrollbar">

            {(node.type === 'video-hub' && !showAutoresponder) ? (
              /* Video Hub Curriculum Builder renders below */
              null
            ) : (
              <div className="space-y-6 text-left">
                {/* Title Field (only for capture-popup nodes) */}
                {node.type === 'capture-popup' && (
                  <div className="space-y-1.5">
                    <label className="text-[9px] font-black text-slate-500 uppercase tracking-widest block">Popup Node Title</label>
                    <input 
                      type="text" 
                      value={node.title || ''} 
                      onChange={e => onUpdateNode(node.id, { title: e.target.value })}
                      placeholder="E.g. Capture Popup"
                      className="w-full bg-slate-955 border border-slate-850 text-white font-medium text-xs px-3.5 py-2.5 rounded-xl focus:border-purple-500 outline-none transition-all placeholder:text-slate-800"
                    />
                  </div>
                )}

                {/* Autoresponder Provider Mode Tabs */}
                <div className="flex items-center gap-2 p-1 bg-slate-955 border border-slate-800 rounded-xl">
                  <button
                    type="button"
                    onClick={() => {
                      setArTab('mailerxp');
                      updateField('autoresponderProvider', 'mailerxp');
                      if (node.type === 'capture-popup') updateCaptureField('autoresponderProvider', 'mailerxp');
                    }}
                    className={`flex-1 py-2 px-3 rounded-lg text-xs font-bold transition-all cursor-pointer flex items-center justify-center gap-1.5 ${
                      arTab === 'mailerxp'
                        ? 'bg-purple-600 text-white shadow-md shadow-purple-600/25'
                        : 'text-slate-400 hover:text-white'
                    }`}
                  >
                    <span>📬</span>
                    <span>MailerXP</span>
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setArTab('custom_html');
                      updateField('autoresponderProvider', 'custom_html');
                      if (node.type === 'capture-popup') updateCaptureField('autoresponderProvider', 'custom_html');
                    }}
                    className={`flex-1 py-2 px-3 rounded-lg text-xs font-bold transition-all cursor-pointer flex items-center justify-center gap-1.5 ${
                      arTab === 'custom_html'
                        ? 'bg-indigo-600 text-white shadow-md shadow-indigo-600/25'
                        : 'text-slate-400 hover:text-white'
                    }`}
                  >
                    <span>📝</span>
                    <span>Custom Form</span>
                  </button>
                </div>

                {/* Option 1: MailerXP Autoresponder */}
                {arTab === 'mailerxp' && (
                  <div className="space-y-4 animate-in fade-in duration-150">
                    {!profile?.mailerXpApi ? (
                      <div className="p-4 rounded-2xl bg-purple-500/10 border border-purple-500/25 space-y-3">
                        <div className="flex items-center space-x-2 text-purple-400">
                          <Zap size={16} />
                          <span className="text-xs font-extrabold uppercase tracking-wider">Connect MailerXP</span>
                        </div>
                        <p className="text-[11px] text-slate-400 leading-relaxed">
                          Enter your MailerXP API Key below to load your subscriber lists and sync leads automatically from this optin page.
                        </p>
                        <div className="space-y-2 pt-1">
                          <input 
                            type="text" 
                            value={inlineApiKey} 
                            onChange={e => setInlineApiKey(e.target.value)} 
                            placeholder="Paste MailerXP API Key (e.g. mxp_live_...)" 
                            className="w-full bg-slate-955 border border-slate-850 text-white font-mono text-xs px-3.5 py-2.5 rounded-xl focus:border-purple-500 outline-none transition-all placeholder:text-slate-700 shadow-inner" 
                          />
                          <button 
                            type="button" 
                            onClick={() => handleSaveInlineApiKey(inlineApiKey)} 
                            disabled={savingApiKey || !inlineApiKey.trim()} 
                            className="w-full py-2.5 bg-purple-600 hover:bg-purple-500 disabled:opacity-50 text-white text-[10px] font-black rounded-xl uppercase tracking-wider transition-all flex items-center justify-center gap-1.5 shadow-lg shadow-purple-600/20" 
                          >
                            {savingApiKey ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : 'Connect MailerXP'}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="space-y-5">
                        {/* Connection status badge */}
                        <div className="flex items-center justify-between px-3 py-2 rounded-xl bg-purple-500/10 border border-purple-500/20">
                          <div className="flex items-center gap-1.5 text-purple-400 text-[10px] font-bold">
                            <Check size={12} className="text-emerald-400" />
                            <span>MailerXP Active</span>
                          </div>
                          <span className="text-[9px] font-mono text-slate-500">
                            ...{profile.mailerXpApi.slice(-6)}
                          </span>
                        </div>

                        {loadingMailerXp ? (
                          <div className="flex flex-col items-center justify-center py-8 space-y-2">
                            <Loader2 className="w-6 h-6 text-indigo-500 animate-spin shrink-0" />
                            <span className="text-[10px] font-black text-slate-500 uppercase tracking-widest">Loading lists & segments...</span>
                          </div>
                        ) : mailerXpError ? (
                          <div className="p-4 rounded-2xl bg-rose-500/10 border border-rose-500/25 space-y-3">
                            <div className="flex items-center space-x-2 text-rose-400">
                              <Zap size={16} />
                              <span className="text-xs font-extrabold uppercase tracking-wider">Connection Error</span>
                            </div>
                            <p className="text-[11px] text-slate-300 leading-relaxed font-mono">
                              {mailerXpError}
                            </p>
                            <button
                              type="button"
                              onClick={fetchLists}
                              className="px-3 py-1.5 bg-rose-500/20 hover:bg-rose-500/30 text-rose-300 text-[10px] font-bold rounded-lg transition-all"
                            >
                              Try Again
                            </button>
                          </div>
                        ) : (
                          <>
                            {/* Lists Dropdown */}
                            <div className="space-y-1.5">
                              <div className="flex items-center justify-between">
                                <label className="text-[9px] font-black text-slate-500 uppercase tracking-widest block">Subscriber List</label>
                                <div className="flex items-center gap-2">
                                  <button
                                    type="button"
                                    onClick={fetchLists}
                                    title="Refresh lists from MailerXP"
                                    className="text-[9px] text-slate-400 hover:text-white font-bold uppercase tracking-wider flex items-center gap-1 transition-colors"
                                  >
                                    <span>🔄 Refresh</span>
                                  </button>
                                  {!showCreateList && (
                                    <button
                                      type="button"
                                      onClick={() => setShowCreateList(true)}
                                      className="text-[9px] text-purple-400 hover:text-purple-300 font-bold uppercase tracking-wider flex items-center gap-0.5 transition-colors"
                                    >
                                      <span>➕ Create List</span>
                                    </button>
                                  )}
                                </div>
                              </div>

                              {/* Inline Create List Card */}
                              {showCreateList && (
                                <div className="p-3 rounded-xl bg-slate-955 border border-purple-500/30 space-y-2 mb-2 animate-in fade-in duration-150">
                                  <div className="text-[10px] font-black text-purple-400 uppercase tracking-wider">Create New List in MailerXP</div>
                                  <input
                                    type="text"
                                    value={newListName}
                                    onChange={e => setNewListName(e.target.value)}
                                    placeholder="e.g. Weight Loss Leads"
                                    className="w-full bg-slate-900 border border-slate-800 text-white text-xs px-3 py-2 rounded-lg focus:border-purple-500 outline-none"
                                    autoFocus
                                    onKeyDown={e => { if (e.key === 'Enter') handleCreateList(); }}
                                  />
                                  {createListError && <p className="text-[10px] text-rose-400">{createListError}</p>}
                                  <div className="flex gap-2">
                                    <button
                                      type="button"
                                      onClick={handleCreateList}
                                      disabled={creatingList || !newListName.trim()}
                                      className="flex-1 py-1.5 bg-purple-600 hover:bg-purple-500 disabled:opacity-50 text-white text-[9px] font-black rounded-lg uppercase tracking-wider transition-all flex items-center justify-center gap-1"
                                    >
                                      {creatingList ? 'Creating...' : 'Create & Select'}
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => { setShowCreateList(false); setNewListName(''); setCreateListError(null); }}
                                      className="px-3 py-1.5 bg-slate-800 hover:bg-slate-700 text-slate-400 text-[9px] font-black rounded-lg uppercase tracking-wider transition-all"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              )}

                              <select 
                                value={pc.mailerXpList || captureNode?.pageContent?.mailerXpList || campaignData?.mailerXpList || ''} 
                                onChange={e => {
                                  const chosen = e.target.value;
                                  updateField('mailerXpList', chosen);
                                  if (campaignData) {
                                    campaignData.mailerXpList = chosen;
                                    campaignData.collectEmails = true;
                                  }
                                  if (node.type === 'capture-popup') {
                                    updateCaptureField('mailerXpList', chosen);
                                  }
                                }}
                                className="w-full bg-slate-955 border border-slate-850 text-white font-medium text-xs px-3.5 py-2.5 rounded-xl focus:border-purple-500 outline-none transition-all cursor-pointer"
                              >
                                <option value="">-- Select MailerXP List --</option>
                                {mailerXpLists.map(list => (
                                  <option key={list?.id || list?.uid} value={list?.id || list?.uid}>
                                    {list?.name || ''} {list?.stats?.subscribers !== undefined ? `(${list.stats.subscribers} leads)` : ''}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* Segments Dropdown */}
                            <div className="space-y-1.5">
                              <label className="text-[9px] font-black text-slate-500 uppercase tracking-widest block">List Segment (Optional)</label>
                              <select 
                                value={pc.mailerXpSegment || captureNode?.pageContent?.mailerXpSegment || ''} 
                                onChange={e => {
                                  const chosen = e.target.value;
                                  updateField('mailerXpSegment', chosen);
                                  if (node.type === 'capture-popup') {
                                    updateCaptureField('mailerXpSegment', chosen);
                                  }
                                }}
                                className="w-full bg-slate-955 border border-slate-850 text-white font-medium text-xs px-3.5 py-2.5 rounded-xl focus:border-purple-500 outline-none transition-all cursor-pointer"
                              >
                                <option value="">-- No Segment (All Subscribers) --</option>
                                {mailerXpSegments.map(seg => (
                                  <option key={seg?.id || seg?.uid} value={seg?.id || seg?.uid}>
                                    {seg?.name || ''}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* Integration success info */}
                            {(pc.mailerXpList || captureNode?.pageContent?.mailerXpList || campaignData?.mailerXpList) ? (
                              <div className="p-3.5 rounded-2xl bg-emerald-500/10 border border-emerald-500/25 space-y-1.5 text-emerald-400">
                                <div className="flex items-center space-x-1.5">
                                  <span className="size-2 bg-emerald-500 rounded-full animate-ping" />
                                  <span className="text-[10px] font-black uppercase tracking-wider">Connected & Active</span>
                                </div>
                                <p className="text-[10px] text-slate-300 leading-relaxed">
                                  Leads collected from this optin page will automatically save to <strong className="text-white">{mailerXpLists.find(l => (l.id || l.uid) === (pc.mailerXpList || captureNode?.pageContent?.mailerXpList || campaignData?.mailerXpList))?.name || 'your chosen list'}</strong> in MailerXP.
                                </p>
                              </div>
                            ) : (
                              <div className="p-3.5 rounded-2xl bg-slate-955 border border-slate-850 text-[10px] text-slate-400 leading-relaxed">
                                💡 Select an existing list above or click <strong>➕ Create List</strong> to start syncing leads automatically.
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Option 2: Custom HTML Form Embed (AWeber, GetResponse, etc.) */}
                {arTab === 'custom_html' && (
                  <div className="space-y-4 animate-in fade-in duration-150">
                    <div className="space-y-1">
                      <div className="flex items-center justify-between">
                        <label className="text-[10px] font-black uppercase tracking-wider text-indigo-300 block">
                          Paste Form Embed HTML
                        </label>
                        <span className="text-[9px] text-slate-500 font-mono">AWeber, GetResponse, etc.</span>
                      </div>
                      <p className="text-[10px] text-slate-400 leading-relaxed font-sans">
                        Paste the raw HTML form embed code from your autoresponder. AffiliateFlow will extract the form action URL, email input name, and hidden tokens.
                      </p>
                    </div>

                    <textarea
                      rows={5}
                      value={rawFormInput}
                      onChange={e => handleParseVisualCustomForm(e.target.value)}
                      placeholder='<form action="https://www.aweber.com/scripts/addlead.pl" method="post">
  <input type="hidden" name="listname" value="awlist..." />
  <input type="email" name="email" />
  <input type="submit" value="Submit" />
</form>'
                      className="w-full bg-slate-955 border border-slate-850 focus:border-indigo-500 rounded-xl p-3 text-xs text-white font-mono outline-none resize-none placeholder:text-slate-700 leading-relaxed shadow-inner"
                    />

                    {customFormError && (
                      <div className="p-3 rounded-xl bg-rose-500/10 border border-rose-500/20 text-rose-400 text-xs flex items-center gap-2">
                        <span>⚠️</span>
                        <span>{customFormError}</span>
                      </div>
                    )}

                    {(() => {
                      const activeCf = pc.customForm || captureNode?.pageContent?.customForm;
                      if (!activeCf || !activeCf.action) return (
                        <div className="p-3.5 rounded-2xl bg-slate-955 border border-slate-850 text-[10px] text-slate-500 leading-relaxed">
                          💡 Paste your raw HTML form code above to connect any third-party autoresponder (AWeber, GetResponse, ActiveCampaign, Mailchimp, ConvertKit, Sendlane, etc.).
                        </div>
                      );

                      return (
                        <div className="p-4 rounded-2xl bg-indigo-500/10 border border-indigo-500/25 space-y-3 animate-in fade-in duration-150">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-1.5 text-emerald-400 text-xs font-bold">
                              <span className="size-2 bg-emerald-400 rounded-full animate-pulse" />
                              <span>Connected to {activeCf.provider || 'Custom Autoresponder'}</span>
                            </div>
                            <span className="text-[9px] font-mono text-slate-400 bg-slate-950 px-2 py-0.5 rounded border border-slate-800">
                              {activeCf.method || 'POST'}
                            </span>
                          </div>

                          <div className="space-y-2 text-xs font-mono">
                            <div className="p-2.5 rounded-xl bg-slate-955 border border-slate-850">
                              <span className="text-[8px] uppercase tracking-wider text-slate-500 block">Form Post Action URL</span>
                              <span className="text-white truncate block text-[11px] select-all" title={activeCf.action}>
                                {activeCf.action}
                              </span>
                            </div>

                            <div className="p-2.5 rounded-xl bg-slate-955 border border-slate-850 flex items-center justify-between">
                              <div>
                                <span className="text-[8px] uppercase tracking-wider text-slate-500 block">Email Field</span>
                                <strong className="text-indigo-300 text-[11px]">{activeCf.emailField || 'email'}</strong>
                              </div>
                              <div>
                                <span className="text-[8px] uppercase tracking-wider text-slate-500 block">Name Field</span>
                                <strong className="text-indigo-300 text-[11px]">{activeCf.nameField || 'none'}</strong>
                              </div>
                            </div>
                          </div>

                          <div className="text-[10px] text-slate-400 flex items-center justify-between pt-1">
                            <span>🏷️ Hidden Parameters: <strong className="text-white">{activeCf.hiddenCount || Object.keys(activeCf.hiddenFields || {}).length} detected</strong></span>
                            <span className="text-emerald-400 font-bold">✓ Ready</span>
                          </div>

                          <p className="text-[10px] text-slate-400 leading-relaxed border-t border-indigo-500/15 pt-2">
                            Leads collected on this optin page will be automatically forwarded to your <strong>{activeCf.provider || 'autoresponder'}</strong> form.
                          </p>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
            )}

            {(node.type === 'video-hub' && !showAutoresponder) && (
              <div className="space-y-6 text-left">
                {/* Course Meta Info */}
                <div className="space-y-3 bg-slate-950/40 p-4 border border-slate-850 rounded-2xl">
                  <div className="space-y-1.5">
                    <label className="text-[9px] font-black text-slate-500 uppercase tracking-widest block">Course Headline</label>
                    <input 
                      type="text" 
                      value={pc.headline || ''} 
                      onChange={e => updateField('headline', e.target.value)}
                      placeholder="E.g. Affiliate Marketing Mastery"
                      className="w-full bg-slate-955 border border-slate-850 text-white font-medium text-xs px-3.5 py-2.5 rounded-xl focus:border-indigo-500 outline-none transition-all placeholder:text-slate-800"
                    />
                  </div>
                  <div className="space-y-1.5">
                    <label className="text-[9px] font-black text-slate-500 uppercase tracking-widest block">Course Description</label>
                    <textarea 
                      value={pc.description || ''} 
                      onChange={e => updateField('description', e.target.value)}
                      placeholder="Watch the lessons below..."
                      rows={2}
                      className="w-full bg-slate-955 border border-slate-850 text-white font-medium text-xs px-3.5 py-2.5 rounded-xl focus:border-indigo-500 outline-none transition-all placeholder:text-slate-800 resize-none"
                    />
                  </div>
                </div>

                {/* Sections & Lessons */}
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest block">Modules & Curriculum</label>
                    <button 
                      onClick={() => {
                        const sections = [...(pc.courseData?.sections || defaultCourseData.sections)];
                        sections.push({
                          title: `Module 0${sections.length + 1}: New Section`,
                          lessons: []
                        });
                        updateField('courseData', { ...pc.courseData, sections });
                      }}
                      className="text-[9px] font-black text-indigo-400 hover:text-indigo-300 uppercase tracking-widest flex items-center gap-1 transition-all"
                    >
                      ➕ Add Module
                    </button>
                  </div>

                  {(() => {
                    const sections = pc.courseData?.sections || defaultCourseData.sections;
                    return sections.map((sec, secIdx) => (
                      <div key={secIdx} className="border border-slate-850 rounded-2xl overflow-hidden bg-slate-950/20">
                        {/* Section Header */}
                        <div className="bg-slate-900/60 px-4 py-3 flex items-center justify-between border-b border-slate-850/60">
                          <input 
                            type="text"
                            value={sec.title}
                            onChange={e => {
                              const updated = [...sections];
                              updated[secIdx].title = e.target.value;
                              updateField('courseData', { ...pc.courseData, sections: updated });
                            }}
                            className="bg-transparent text-white font-bold text-xs outline-none border-b border-transparent focus:border-indigo-500 w-3/4"
                          />
                          <button 
                            onClick={() => {
                              const updated = sections.filter((_, i) => i !== secIdx);
                              updateField('courseData', { ...pc.courseData, sections: updated });
                            }}
                            title="Delete Section"
                            className="text-slate-500 hover:text-rose-400 text-xs transition-colors"
                          >
                            ✕
                          </button>
                        </div>

                        {/* Lessons List inside Section */}
                        <div className="p-3.5 space-y-3">
                          {sec.lessons && sec.lessons.map((les, lesIdx) => (
                            <div key={lesIdx} className="bg-slate-950/40 border border-slate-900 rounded-xl p-3 space-y-2.5 relative">
                              <div className="flex justify-between items-center">
                                <span className="text-[8px] font-black text-slate-500 uppercase tracking-wider">Lesson 0{lesIdx + 1}</span>
                                <button 
                                  onClick={() => {
                                    const updated = [...sections];
                                    updated[secIdx].lessons = sec.lessons.filter((_, i) => i !== lesIdx);
                                    updateField('courseData', { ...pc.courseData, sections: updated });
                                  }}
                                  className="text-slate-600 hover:text-rose-400 text-[10px] transition-colors"
                                >
                                  Remove
                                </button>
                              </div>

                              <input 
                                type="text"
                                value={les.title}
                                placeholder="Lesson title..."
                                onChange={e => {
                                  const updated = [...sections];
                                  updated[secIdx].lessons[lesIdx].title = e.target.value;
                                  updateField('courseData', { ...pc.courseData, sections: updated });
                                }}
                                className="w-full bg-slate-955 border border-slate-900 text-white font-semibold text-[10px] px-2.5 py-1.5 rounded-lg focus:border-indigo-500 outline-none placeholder:text-slate-800"
                              />

                              <input 
                                type="text"
                                value={les.videoUrl}
                                placeholder="Video URL (YouTube or direct MP4)..."
                                onChange={e => {
                                  const updated = [...sections];
                                  updated[secIdx].lessons[lesIdx].videoUrl = e.target.value;
                                  updateField('courseData', { ...pc.courseData, sections: updated });
                                }}
                                className="w-full bg-slate-955 border border-slate-900 text-slate-350 text-[9px] px-2.5 py-1.5 rounded-lg focus:border-indigo-500 outline-none placeholder:text-slate-800"
                              />

                              <div className="flex gap-2">
                                <input 
                                  type="text"
                                  value={les.dur}
                                  placeholder="Duration (e.g. 5m 30s)..."
                                  onChange={e => {
                                    const updated = [...sections];
                                    updated[secIdx].lessons[lesIdx].dur = e.target.value;
                                    updateField('courseData', { ...pc.courseData, sections: updated });
                                  }}
                                  className="w-1/2 bg-slate-955 border border-slate-900 text-slate-400 text-[9px] px-2.5 py-1.5 rounded-lg focus:border-indigo-500 outline-none placeholder:text-slate-800"
                                />
                                <input 
                                  type="text"
                                  value={les.desc || ''}
                                  placeholder="Brief description..."
                                  onChange={e => {
                                    const updated = [...sections];
                                    updated[secIdx].lessons[lesIdx].desc = e.target.value;
                                    updateField('courseData', { ...pc.courseData, sections: updated });
                                  }}
                                  className="w-1/2 bg-slate-955 border border-slate-900 text-slate-400 text-[9px] px-2.5 py-1.5 rounded-lg focus:border-indigo-500 outline-none placeholder:text-slate-800"
                                />
                              </div>
                            </div>
                          ))}

                          <button 
                            onClick={() => {
                              const updated = [...sections];
                              if (!updated[secIdx].lessons) updated[secIdx].lessons = [];
                              updated[secIdx].lessons.push({
                                title: `Lesson ${updated[secIdx].lessons.length + 1}`,
                                videoUrl: '',
                                dur: '10m 00s',
                                desc: ''
                              });
                              updateField('courseData', { ...pc.courseData, sections: updated });
                            }}
                            className="w-full py-1.5 border border-dashed border-slate-850 hover:border-slate-700 rounded-xl text-[9px] font-black text-slate-500 hover:text-slate-350 uppercase tracking-widest transition-all text-center"
                          >
                            ➕ Add Lesson
                          </button>
                        </div>
                      </div>
                    ));
                  })()}
                </div>
              </div>
            )}

          </div>
        </aside>
        )}
      </div>

    </div>
  );
};

export default VisualPageEditor;

